const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketLaunch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2000 1333.3333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1333.3333)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#193757",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 15000 V 10000 H 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#24588f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 113.867,3930.67 c 507.289,537.1 1155.473,73.77 1196.043,-67.5 0,324.6 1479.05,1157.94 2473.09,135.39 539.99,422.55 1546.24,171.44 1641.52,-480.39 741.29,334.85 1182.55,-212.18 1182.55,-212.18 0,0 10.79,0 44.99,0.52 105.89,268.49 510.44,151.26 557.98,0 290.69,801.26 1510.5,854.94 1876.56,183.49 229.59,1287.6 2223.4,1180.59 2455.1,622.77 428.3,725 1348.3,335 1383.3,-25 180,390 821.7,58.9 695,-224.44 193.3,116.67 386.5,-293.49 386.5,-293.49 0,0 99.8,24.81 136.8,-34.57 346.7,509.17 856.7,151.35 856.7,151.35 V 1862.58 L 0,1898.03 v 2138.88 c 55.25,-35.88 95.2891,-72.82 113.867,-106.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#316fb7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 682.164,2856.67 C 910,4008.64 2941.27,3876.67 3136.67,3158.04 3223.33,3410 3666.84,3363.33 3666.84,3013.45 3790,3714.6 5645,3909.6 5922.55,2726.78 6283.9,3344.6 7500,3290 7717.7,2405.11 c 62.3,833.61 1207.3,859.49 1598.49,366.08 172.54,1006.72 2067.41,1033.41 2067.41,512.26 123.4,521.15 1021.7,521.15 1290.2,67.5 501.9,757.14 2023.3,483.09 2324.7,-106.91 3.5,-1382.76 -0.3,-1648.04 0,-1709.44 H 0 v 1492.95 c 269.152,45.41 545.305,-34.01 682.164,-170.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#4183cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14886.1,2427.27 c -507.3,537.1 -1155.4,73.76 -1196,-67.5 0,324.6 -1479.1,1157.93 -2473.1,135.38 -540,422.55 -1641.52,-37.45 -1641.52,-480.38 -741.29,334.84 -1182.55,-212.18 -1182.55,-212.18 0,0 -10.79,0 -44.99,0.51 -177.94,268.77 -510.44,151.27 -557.98,0 -290.69,801.27 -1213.29,1047.93 -1747.72,693.33 -448.96,928.18 -2352.24,670.76 -2583.96,112.94 -428.28,725 -1348.28,335 -1383.28,-25 -180,390 -728.33,66.66 -655,-155 -450,78.33 -426.523,-362.94 -426.523,-362.94 0,0 -99.727,24.81 -136.809,-34.56 C 510,2541.03 0,2183.21 0,2183.21 V 359.18 l 15000,35.449 V 2533.5 c -55.2,-35.88 -95.3,-72.82 -113.9,-106.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#d2f0fa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14317.8,2970 c -197.8,221.06 -498.1,310.48 -820.6,302.66 l 0.7,0.51 c -2.2,-0.27 -4.5,-0.45 -6.8,-0.69 -19.3,-0.54 -38.8,-1.43 -58.3,-2.67 C 12283,3350 10457.5,5131.95 9923.75,5635 l -72.48,-74.63 C 10178,5027.87 11627.3,3579.32 11868.8,2236.5 11670,2165 11597.6,1895 11796.6,1623.44 c 0,0 -306.6,191.56 -463.4,-144.59 C 11210,2180 9355,2375 9077.45,1192.18 8716.1,1810 7927.35,1853.33 7424.82,1403.85 7349.33,2156.67 6217.52,2263.33 5826.33,1769.93 5270.94,2916.67 3616.43,2270 3616.43,1748.85 3493.02,2270 2594.67,2270 2326.22,1816.35 1824.29,2573.5 302.898,2299.44 1.45313,1709.44 -1.96484,326.68 1.76563,61.4023 1.45313,0 H 15000 v 3140.88 c -269.2,45.41 -545.3,-34.01 -682.2,-170.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10822.7,8443.92 c -7.2,-27.18 -27.8,-43.17 -62.8,-47.13 33.9,-4.54 52.8,-21.98 62.8,-47.13 9.5,25.14 30.1,41.13 62.8,47.13 -35.2,2.82 -55.1,19.52 -62.8,47.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6224.2,8980.49 c -6.42,-6 -14.24,-7.96 -23.53,-5.58 7.57,-4.37 9.25,-10.49 7.43,-17.65 6.64,5.28 14.45,7.24 23.54,5.57 -8.21,4.09 -10.25,10.11 -7.44,17.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7333.22,9542.8 c 2.86,-8.87 -0.35,-15.79 -10.06,-20.61 10.95,2.17 19.83,-1.08 27.47,-7.55 -1.8,8.5 1.4,15.43 10.06,20.62 -11.05,-2.83 -20.06,0.1 -27.47,7.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8425.76,7297.43 c 6.8,-8.86 6.26,-17.05 -2.16,-24.53 10.86,4.91 21.77,3.52 32.7,-1.62 -5.5,8.71 -4.97,16.9 2.16,24.53 -10.69,-5.64 -21.61,-4.63 -32.7,1.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8069.14,7533.62 c 5.6,-6.43 5.65,-12.6 -0.26,-18.48 7.88,4.03 16.14,3.33 24.63,-0.19 -4.61,6.37 -4.67,12.53 0.26,18.48 -7.71,-4.57 -15.96,-4.15 -24.63,0.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8150.99,7575.57 c -8.87,-11.44 -21.48,-16.27 -38.09,-14.01 14.36,-5.97 19.31,-16.05 18.67,-28.58 9.48,10.26 22.08,15.09 38.09,14.01 -15.34,5.36 -20.87,15.21 -18.67,28.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10352.1,6950.18 c 2.6,-6.82 0.4,-12.27 -6.9,-16.24 8.4,1.94 15.4,-0.37 21.6,-5.21 -1.8,6.55 0.4,12 6.9,16.23 -8.4,-2.45 -15.5,-0.39 -21.6,5.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 453.141,8661.77 c 0.875,-13.79 -6.508,-23.37 -22.762,-28.46 17.078,0.88 29.027,-5.84 37.918,-17.08 0.555,13.01 7.933,22.6 22.762,28.46 -17.473,-1.83 -29.743,4.44 -37.918,17.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5780.9,7820.6 c -4.95,-11.45 -14.92,-17.57 -30.28,-17.96 14.3,-3.24 21.3,-11.48 23.93,-22.72 5.8,10.49 15.77,16.61 30.28,17.96 -15.01,2.55 -22.45,10.51 -23.93,22.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1775.14,5186.33 c -7.14,-10.68 -18.14,-15.56 -33.27,-14.21 13.37,-4.78 18.59,-13.66 18.93,-24.97 7.78,9.64 18.77,14.52 33.27,14.21 -14.21,4.19 -19.92,12.83 -18.93,24.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8065.24,8196.01 c 2.87,-10.57 -1.31,-18.63 -13.05,-24.01 13.05,2.21 23.34,-1.91 31.99,-9.79 -1.63,10.09 2.53,18.16 13.05,24.01 -13.2,-2.98 -23.66,0.76 -31.99,9.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7439.62,8304.67 c -11.2,-7.95 -24.17,-8.17 -38.54,-2.28 9.95,-9.48 11.18,-19.12 3.04,-28.92 11.57,7.12 24.61,6.89 38.54,2.28 -8.4,9.47 -9.63,19.1 -3.04,28.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6881.01,8768.78 c -5.52,-6.41 -12.96,-8.95 -22.45,-7.31 8.06,-3.73 10.56,-9.64 9.74,-16.84 5.83,5.72 13.26,8.25 22.45,7.3 -8.65,3.4 -11.48,9.19 -9.74,16.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5763.03,9541.68 c 6.66,-8.09 6.47,-15.72 -1.07,-22.86 9.91,4.81 20.1,3.76 30.46,-0.79 -5.45,7.98 -5.27,15.61 1.07,22.86 -9.72,-5.48 -19.91,-4.78 -30.46,0.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2215.64,9447.04 c 3.23,-8.78 0.33,-15.75 -9.15,-20.79 10.83,2.42 19.81,-0.6 27.71,-6.87 -2.16,8.44 0.74,15.41 9.15,20.79 -10.9,-3.07 -20,-0.37 -27.71,6.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4055.15,9028.17 c 3.05,-7.37 0.84,-13.33 -7.02,-17.79 9.09,2.26 16.81,-0.11 23.72,-5.27 -2.13,7.1 0.08,13.07 7.01,17.8 -9.12,-2.82 -16.93,-0.72 -23.71,5.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 457.172,8058.76 c 3.43,-7.65 1.32,-13.92 -6.731,-18.72 9.411,2.54 17.559,0.2 24.946,-5.05 -2.457,7.37 -0.356,13.65 6.734,18.71 -9.433,-3.12 -17.66,-1.06 -24.949,5.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4258.15,8137.64 c 5.95,-9.36 4.55,-17.61 -4.75,-24.68 11.5,4.33 22.38,2.29 32.9,-3.57 -4.65,9.14 -3.26,17.4 4.75,24.69 -11.4,-5.08 -22.34,-3.41 -32.9,3.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 286.41,9444.66 c -0.472,-6.79 -4.722,-11.23 -13.031,-13.12 8.437,-0.2 13.863,-3.93 17.488,-9.78 1.125,6.37 5.371,10.79 13.035,13.13 -8.695,-0.26 -14.304,3.27 -17.492,9.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1836.34,8610.12 c -12.55,-8.47 -26.76,-8.44 -42.27,-1.71 10.55,-10.58 11.54,-21.15 2.29,-31.72 12.91,7.57 27.18,7.05 42.26,1.72 -8.85,10.54 -9.85,21.11 -2.28,31.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1184.89,9638.96 c -3.99,-6.87 -10.66,-10.21 -20.21,-9.75 8.6,-2.66 12.27,-8.09 12.99,-15.17 4.44,6.24 11.11,9.58 20.21,9.75 -9.09,2.26 -13.06,7.53 -12.99,15.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4963.28,9499.02 c -9.11,-8.13 -19.95,-10.64 -32.66,-7.13 10.25,-6.21 12.31,-14.68 9.5,-24.51 9.37,7.12 20.21,9.64 32.66,7.13 -11.13,5.82 -13.69,14.17 -9.5,24.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4717.69,6859.25 c 1.97,-9.55 -2.23,-16.63 -13.05,-21.07 11.81,1.56 20.79,-2.46 28.08,-9.79 -0.89,9.09 3.3,16.17 13.05,21.07 -11.98,-2.24 -21.14,1.45 -28.08,9.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3801.71,6643.23 c -2.16,-7.59 -8.02,-12.01 -17.84,-13.03 9.47,-1.36 14.68,-6.31 17.37,-13.38 2.8,7.02 8.65,11.44 17.84,13.03 -9.86,0.89 -15.34,5.62 -17.37,13.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 290.438,7543.35 c -6.11,-8.9 -15.375,-12.91 -28.036,-11.68 11.149,-4.09 15.407,-11.56 15.563,-21.03 6.629,8.01 15.89,12.03 28.027,11.67 -11.851,3.61 -16.527,10.88 -15.554,21.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1879.75,9121.61 c -11.85,-7.56 -24.92,-7.24 -38.96,-0.73 9.33,-9.95 9.87,-19.7 0.98,-29.24 12.15,6.7 25.26,5.94 38.95,0.73 -7.77,9.87 -8.32,19.62 -0.97,29.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2525.29,7016.66 c -7.59,-6.7 -17.37,-7.65 -28.86,-4.09 8.55,-6.55 10.52,-13.75 5.45,-21.66 7.96,6.09 17.84,6.72 28.86,4.09 -7.38,6.64 -9.36,13.84 -5.45,21.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5895.69,4403.15 c 1.53,-9.87 -3.15,-17.04 -14.5,-21.29 12.22,1.26 21.25,-3.13 28.37,-10.89 -0.45,9.38 4.23,16.54 14.51,21.3 -12.44,-1.96 -21.67,2.1 -28.38,10.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1318.02,7557.02 c 6.17,-8.94 5.16,-16.98 -3.56,-24.06 10.97,4.48 21.62,2.75 32.07,-2.67 -4.9,8.75 -3.9,16.8 3.56,24.07 -10.84,-5.21 -21.52,-3.85 -32.07,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1102.56,8310.55 c -3.83,-11.66 -13.17,-18.28 -28.41,-19.49 14.54,-2.46 22.28,-10.28 25.98,-21.32 4.77,10.75 14.1,17.37 28.4,19.49 -15.17,1.74 -23.33,9.25 -25.97,21.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3177.29,8429.7 c -2.11,-13.43 -11.29,-21.8 -28.08,-24.75 16.68,-1.22 26.79,-9.14 32.98,-21.07 3.32,12.5 12.5,20.87 28.08,24.75 -17.27,0.34 -27.79,7.87 -32.98,21.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8109.12,9042.73 c 3.24,-8.14 0.72,-14.68 -7.98,-19.53 10.03,2.43 18.49,-0.26 26.02,-5.99 -2.24,7.84 0.28,14.38 7.98,19.53 -10.08,-3.03 -18.64,-0.65 -26.02,5.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10892.6,8891.97 c -6.3,-6.24 -14.1,-8.41 -23.6,-6.21 7.8,-4.25 9.8,-10.41 8.2,-17.71 6.5,5.51 14.4,7.68 23.6,6.2 -8.5,3.95 -10.8,10 -8.2,17.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9435.91,8827.38 c 1.62,-6.65 -1.14,-11.67 -8.6,-14.93 8.22,1.25 14.61,-1.42 19.9,-6.45 -0.86,6.35 1.9,11.36 8.6,14.93 -8.34,-1.74 -14.84,0.71 -19.9,6.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9224.73,7051.57 c -6.25,-11.74 -17.26,-17.62 -33.37,-17.21 14.67,-4.14 21.22,-13.15 22.93,-25.04 7.05,10.68 18.05,16.56 33.37,17.21 -15.48,3.46 -22.53,12.18 -22.93,25.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12662.2,9044.91 c -5.4,-8.15 -13.7,-11.89 -25.2,-10.89 10.2,-3.62 14.2,-10.36 14.5,-18.98 5.9,7.35 14.2,11.1 25.2,10.89 -10.8,3.16 -15.2,9.73 -14.5,18.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9158.19,8064.34 c -11.57,-7.09 -24.13,-6.61 -37.46,-0.16 8.72,-9.69 9,-19.07 0.22,-28.12 11.84,6.28 24.43,5.37 37.46,0.17 -7.23,9.6 -7.51,18.97 -0.22,28.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12420,7349.59 c -9.3,-8.13 -20.2,-10.59 -33,-6.96 10.2,-6.34 12.2,-14.91 9.3,-24.81 9.5,7.12 20.5,9.58 33,6.96 -11.1,5.96 -13.6,14.4 -9.3,24.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8876.6,8911.94 c -11.38,-10.28 -25,-13.5 -41.03,-9.16 12.96,-7.75 15.64,-18.4 12.21,-30.79 11.72,9.02 25.34,12.25 41.02,9.16 -14.06,7.26 -17.37,17.76 -12.2,30.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10024.6,9397.36 c -6.6,-5.61 -14.9,-6.33 -24.6,-3.22 7.2,-5.62 8.8,-11.73 4.3,-18.39 6.9,5.09 15.3,5.54 24.6,3.22 -6.2,5.69 -7.8,11.8 -4.3,18.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12671,8006.44 c -9,-6.6 -19.5,-6.91 -31.3,-2.29 8.3,-7.6 9.4,-15.42 3,-23.49 9.3,5.93 19.9,5.89 31.3,2.29 -7,7.61 -8.2,15.43 -3,23.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11882.9,8010.39 c 3.2,-10.59 -0.7,-18.79 -12.3,-24.44 13,2.47 23.5,-1.47 32.5,-9.24 -2,10.14 1.9,18.34 12.3,24.44 -13.2,-3.25 -23.8,0.31 -32.5,9.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11887.9,9036.55 c 4,-6.54 2.9,-12.25 -3.7,-17.07 8.1,2.9 15.6,1.4 22.8,-2.75 -3.1,6.38 -2,12.09 3.6,17.07 -7.9,-3.42 -15.5,-2.17 -22.7,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11884.7,9544.93 c -4.7,-12.97 -15.4,-20.2 -32.5,-21.26 16.2,-3.01 24.6,-11.92 28.4,-24.32 5.7,11.93 16.3,19.16 32.4,21.26 -16.9,2.22 -25.8,10.78 -28.3,24.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8773,9661.25 c -4.69,-12.67 -15.17,-19.69 -31.9,-20.65 15.8,-3.03 23.94,-11.78 27.51,-23.93 5.68,11.64 16.16,18.66 31.9,20.64 -16.53,2.26 -25.14,10.67 -27.51,23.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10593.8,7856.81 c 3.3,-9.17 0.3,-16.46 -9.6,-21.74 11.3,2.54 20.7,-0.6 29,-7.14 -2.3,8.81 0.7,16.1 9.5,21.74 -11.4,-3.23 -20.9,-0.42 -28.9,7.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11726.8,8606.66 c -10.9,-7.27 -23.2,-7.17 -36.6,-1.29 9.1,-9.19 9.8,-18.33 1.8,-27.42 11.2,6.48 23.5,5.97 36.5,1.29 -7.6,9.15 -8.3,18.29 -1.7,27.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2952.88,7846.38 c -14.55,-25.48 -39.11,-37.93 -74.41,-36.39 31.87,-9.68 45.59,-29.68 48.5,-55.84 16.22,23.12 40.77,35.58 74.41,36.39 -33.7,8.21 -48.52,27.62 -48.5,55.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4925.47,8682.88 c 8.56,-26.96 -1.27,-47.94 -30.84,-62.5 33.28,6.48 60.19,-3.43 83.3,-23.14 -5.34,25.83 4.47,46.82 30.83,62.51 -33.58,-8.48 -60.9,0.48 -83.29,23.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7614.43,7616.04 c 1.75,-27.68 -13.09,-46.93 -45.74,-57.13 34.3,1.74 58.29,-11.74 76.14,-34.32 1.13,26.12 15.95,45.38 45.73,57.13 -35.09,-3.66 -59.72,8.94 -76.13,34.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6482.99,7470.18 c -1.33,-27.7 -18.26,-45.95 -51.93,-54.07 34.38,-0.41 56.79,-15.35 72.06,-38.97 4.03,25.96 20.94,44.23 51.93,54.08 -35.38,-1.45 -58.52,12.64 -72.06,38.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 883.84,7217.18 c 7.625,-41.19 -11.059,-71.45 -57.985,-90.01 50.922,6.1 89.208,-11.61 119.95,-43.52 -3.043,39.14 15.617,69.42 57.985,90.01 -51.759,-9.04 -90.841,7.27 -119.95,43.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6203.65,6409.35 c 7.31,-41.22 -11.62,-71.41 -58.69,-89.76 50.98,5.88 89.12,-11.99 119.61,-44.04 -2.73,39.15 16.16,69.35 58.69,89.76 -51.83,-8.82 -90.78,7.66 -119.61,44.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10136.6,8512.88 c 1.4,-41.56 -21.8,-70.04 -71.2,-84.49 51.5,1.73 86.9,-19.12 112.6,-53.44 2.9,39.14 26,67.64 71.2,84.49 -52.8,-4.58 -89.1,14.95 -112.6,53.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 485.652,9116.75 c 23.657,-37.6 17.868,-70.68 -19.539,-98.9 46.176,17.23 89.758,8.9 131.789,-14.66 -18.468,36.67 -12.707,69.75 19.536,98.9 -45.797,-20.23 -89.586,-13.42 -131.786,14.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11531.4,9634.51 c -31.9,-34.01 -73.1,-46.56 -124.3,-36.08 42.8,-21.63 54.7,-54.18 48.1,-93.24 33.4,30.16 74.6,42.73 124.3,36.08 -46.1,19.9 -59.8,51.84 -48.1,93.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2530.74,6322.68 c -7.73,-27.61 -27.57,-44.31 -62.8,-47.13 32.69,-5.99 53.28,-21.99 62.8,-47.13 10.03,25.15 28.96,42.6 62.81,47.13 -34.97,3.97 -55.58,19.95 -62.81,47.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5590.42,6673.48 c 2.86,-8.87 -0.35,-15.79 -10.06,-20.62 10.95,2.17 19.83,-1.07 27.47,-7.54 -1.8,8.5 1.4,15.42 10.06,20.61 -11.05,-2.82 -20.06,0.1 -27.47,7.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13232.2,6183.42 c 0.9,-13.79 -6.5,-23.38 -22.8,-28.46 17.1,0.87 29,-5.84 37.9,-17.08 0.6,13.01 8,22.6 22.8,28.45 -17.5,-1.82 -29.7,4.45 -37.9,17.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4856.86,5326.68 c 2.87,-10.56 -1.3,-18.62 -13.04,-24 13.04,2.2 23.33,-1.91 31.99,-9.79 -1.64,10.09 2.53,18.15 13.05,24 -13.2,-2.97 -23.67,0.77 -32,9.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10706.9,6577.71 c 3.2,-8.77 0.3,-15.75 -9.2,-20.78 10.8,2.42 19.8,-0.6 27.7,-6.87 -2.1,8.43 0.7,15.41 9.2,20.79 -10.9,-3.08 -20,-0.38 -27.7,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8869.2,6158.84 c 3.05,-7.36 0.84,-13.33 -7.01,-17.79 9.08,2.27 16.8,-0.11 23.71,-5.26 -2.13,7.1 0.08,13.07 7.01,17.79 -9.11,-2.82 -16.92,-0.72 -23.71,5.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12465.7,5189.43 c 3.4,-7.64 1.3,-13.91 -6.8,-18.72 9.4,2.54 17.6,0.2 25,-5.05 -2.5,7.38 -0.4,13.65 6.7,18.72 -9.4,-3.12 -17.7,-1.07 -24.9,5.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8654.75,5268.32 c 5.95,-9.36 4.55,-17.62 -4.75,-24.69 11.5,4.34 22.38,2.29 32.9,-3.56 -4.66,9.14 -3.26,17.39 4.75,24.69 -11.41,-5.08 -22.34,-3.41 -32.9,3.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12650.2,6575.34 c -0.5,-6.8 -4.7,-11.23 -13.1,-13.13 8.5,-0.2 13.9,-3.93 17.5,-9.78 1.2,6.37 5.4,10.8 13.1,13.13 -8.7,-0.25 -14.3,3.28 -17.5,9.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11144.7,5740.8 c -12.6,-8.48 -26.8,-8.44 -42.3,-1.72 10.6,-10.57 11.6,-21.14 2.3,-31.71 12.9,7.56 27.2,7.05 42.3,1.72 -8.9,10.53 -9.9,21.1 -2.3,31.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11487.5,6964.33 c -4,-6.88 -10.7,-10.21 -20.2,-9.75 8.6,-2.66 12.3,-8.09 13,-15.17 4.4,6.24 11.1,9.58 20.2,9.75 -9.1,2.27 -13.1,7.54 -13,15.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12663.1,4674.02 c -6.1,-8.89 -15.4,-12.9 -28,-11.67 11.1,-4.1 15.4,-11.56 15.5,-21.04 6.6,8.02 15.9,12.03 28,11.68 -11.8,3.6 -16.5,10.87 -15.5,21.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11099.3,6252.28 c -11.9,-7.55 -24.9,-7.24 -39,-0.73 9.4,-9.95 9.9,-19.7 1,-29.23 12.2,6.7 25.3,5.94 39,0.72 -7.8,9.88 -8.4,19.63 -1,29.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11594.5,4687.7 c 6.2,-8.94 5.2,-16.99 -3.5,-24.07 10.9,4.48 21.6,2.76 32,-2.67 -4.9,8.76 -3.9,16.8 3.6,24.07 -10.9,-5.2 -21.5,-3.84 -32.1,2.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11840.9,5441.23 c -3.8,-11.67 -13.1,-18.29 -28.4,-19.49 14.5,-2.46 22.3,-10.29 26,-21.32 4.8,10.74 14.1,17.37 28.4,19.49 -15.2,1.73 -23.3,9.25 -26,21.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9758.86,5560.37 c -2.1,-13.42 -11.29,-21.8 -28.08,-24.75 16.69,-1.21 26.8,-9.14 32.98,-21.07 3.32,12.5 12.5,20.88 28.08,24.75 -17.27,0.34 -27.78,7.88 -32.98,21.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4813.89,6173.41 c 3.24,-8.14 0.73,-14.69 -7.98,-19.53 10.03,2.42 18.49,-0.26 26.02,-5.99 -2.23,7.83 0.28,14.38 7.98,19.53 -10.08,-3.04 -18.64,-0.65 -26.02,5.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2063.83,6022.64 c -6.26,-6.23 -14.09,-8.4 -23.6,-6.2 7.85,-4.25 9.81,-10.41 8.26,-17.71 6.51,5.5 14.34,7.67 23.61,6.2 -8.48,3.94 -10.8,10 -8.27,17.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3493.84,5958.06 c 1.62,-6.66 -1.14,-11.68 -8.6,-14.93 8.22,1.25 14.61,-1.43 19.9,-6.45 -0.86,6.34 1.9,11.36 8.6,14.92 -8.33,-1.73 -14.84,0.72 -19.9,6.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 289.586,6175.58 c -5.398,-8.15 -13.754,-11.88 -25.285,-10.89 10.203,-3.61 14.207,-10.36 14.508,-18.97 5.89,7.35 14.246,11.09 25.289,10.88 -10.84,3.17 -15.215,9.74 -14.512,18.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3820.1,5195.02 c -11.57,-7.1 -24.13,-6.61 -37.46,-0.17 8.72,-9.68 9,-19.06 0.21,-28.11 11.85,6.27 24.44,5.36 37.47,0.16 -7.23,9.6 -7.52,18.98 -0.22,28.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2936.71,6528.04 c -6.54,-5.61 -14.83,-6.34 -24.51,-3.22 7.14,-5.62 8.71,-11.74 4.29,-18.4 6.83,5.1 15.21,5.55 24.51,3.23 -6.15,5.68 -7.72,11.8 -4.29,18.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 298.324,5137.12 c -8.953,-6.6 -19.5,-6.92 -31.304,-2.29 8.285,-7.6 9.472,-15.43 3.054,-23.49 9.266,5.92 19.879,5.88 31.301,2.28 -7.023,7.61 -8.219,15.44 -3.051,23.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1037.92,5141.06 c 3.26,-10.58 -0.67,-18.79 -12.31,-24.44 13.07,2.48 23.58,-1.46 32.57,-9.23 -2,10.13 1.92,18.34 12.31,24.44 -13.19,-3.26 -23.87,0.31 -32.57,9.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 969.797,4824.19 c 3.258,-10.59 -0.668,-18.79 -12.309,-24.44 13.067,2.47 23.578,-1.47 32.567,-9.24 -2,10.14 1.922,18.34 12.315,24.44 -13.198,-3.25 -23.874,0.31 -32.573,9.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1034.07,6167.22 c 3.98,-6.54 2.89,-12.25 -3.66,-17.07 8.03,2.91 15.54,1.4 22.75,-2.74 -3.09,6.37 -2,12.08 3.65,17.07 -7.97,-3.43 -15.53,-2.18 -22.74,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1060.47,6675.6 c -4.67,-12.96 -15.33,-20.19 -32.41,-21.25 16.17,-3.02 24.57,-11.92 28.33,-24.32 5.69,11.92 16.34,19.15 32.41,21.25 -16.91,2.23 -25.79,10.79 -28.33,24.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4018.63,5985.2 c -4.69,-12.67 -15.17,-19.69 -31.89,-20.65 15.79,-3.03 23.93,-11.77 27.51,-23.93 5.67,11.64 16.15,18.66 31.89,20.64 -16.53,2.26 -25.14,10.68 -27.51,23.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2327.84,4987.48 c 3.4,-9.17 0.38,-16.46 -9.52,-21.74 11.31,2.55 20.71,-0.6 28.97,-7.14 -2.27,8.81 0.74,16.11 9.52,21.74 -11.38,-3.23 -20.9,-0.42 -28.97,7.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1249.09,5737.34 c -10.91,-7.27 -23.19,-7.18 -36.54,-1.29 9.03,-9.19 9.8,-18.33 1.72,-27.42 11.22,6.48 23.55,5.97 36.54,1.29 -7.57,9.14 -8.35,18.28 -1.72,27.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7963.12,5813.56 c 8.56,-26.96 -1.27,-47.94 -30.83,-62.51 33.27,6.49 60.18,-3.43 83.29,-23.13 -5.34,25.83 4.47,46.81 30.83,62.51 -33.58,-8.48 -60.9,0.47 -83.29,23.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14672.1,9730.21 c 1.4,-41.56 -21.8,-70.05 -71.2,-84.49 51.5,1.73 86.9,-19.12 112.6,-53.44 2.9,39.14 26,67.63 71.2,84.49 -52.8,-4.58 -89.1,14.95 -112.6,53.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3001.38,9209.87 c 40.81,-7.96 63.42,-36.86 66.49,-88.26 9.8,50.6 38,80.42 77.19,97.85 -37.51,11.54 -60.13,40.43 -66.49,88.25 -7.3,-52.48 -34.45,-83.57 -77.19,-97.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12343.1,6247.42 c 23.7,-37.6 17.9,-70.67 -19.5,-98.9 46.2,17.24 89.8,8.91 131.8,-14.66 -18.5,36.68 -12.7,69.75 19.5,98.9 -45.8,-20.23 -89.6,-13.42 -131.8,14.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8351.93,8747.55 c -31.88,-34.01 -73.07,-46.56 -124.25,-36.09 42.77,-21.62 54.64,-54.17 48.09,-93.24 33.37,30.17 74.55,42.74 124.25,36.09 -46.05,19.9 -59.78,51.83 -48.09,93.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14769,6419.34 c -7.1,-6.05 -15.4,-7.82 -25,-4.99 7.6,-4.84 9,-11.31 6.6,-18.73 7.3,5.29 15.6,7.06 25,4.99 -8.3,4.56 -10.1,10.93 -6.6,18.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14063,6282.29 c 0.8,-9.29 -5.7,-15.79 -16.6,-20.62 12.6,-0.3 21.9,-4.31 27.5,-12.37 -1.7,9.5 4.3,16.17 16.6,20.62 -13.4,-0.48 -22.6,3.53 -27.5,12.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14580.6,4571.7 c -3.3,-8.82 -10.6,-13.71 -22.3,-14.37 11,-2.12 16.7,-8.22 19.2,-16.7 4,8.11 11.3,13 22.3,14.37 -11.6,1.59 -17.6,7.46 -19.2,16.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14295.7,5316.36 c -10.7,-5.93 -21.3,-6.47 -31.9,-1.22 7.6,-7.31 7,-15.37 1.6,-23.88 10.6,4.98 21.2,5.53 31.9,1.23 -8.5,7.1 -8.4,15.13 -1.6,23.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14620.1,5609.33 c -7.3,-8.48 -17.1,-11.84 -29.6,-9.72 10.6,-4.89 14,-12.67 12.9,-22.17 7.7,7.56 17.5,10.94 29.6,9.73 -11.4,4.44 -15.2,12.05 -12.9,22.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13202.3,4369.93 c -1,-7.23 -7.1,-11.58 -16.3,-14.23 9.6,-1.47 16,-5.47 18.9,-12.23 0.3,7.48 6.2,12.02 16.3,14.23 -10.3,0.95 -16.7,4.95 -18.9,12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12485.5,5597.54 c 0.9,-8.43 -4.9,-14.41 -14.7,-18.91 11.5,-0.15 20,-3.71 25.2,-10.98 -1.7,8.62 3.7,14.75 14.7,18.91 -12.1,-0.57 -20.6,2.99 -25.2,10.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14225.3,4057.77 c -2.9,-7.45 -9.2,-11.52 -19.1,-11.98 9.3,-1.89 14,-7.11 16,-14.31 3.5,6.84 9.8,10.92 19.1,11.98 -9.8,1.44 -14.7,6.47 -16,14.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13425.5,4815.49 c -5.5,-5.85 -12.7,-8 -21.5,-6.16 7.3,-3.76 9.4,-9.39 8.2,-16.14 5.8,5.19 12.9,7.34 21.5,6.16 -7.9,3.46 -10.3,8.99 -8.2,16.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13432.8,5346.31 c 4.6,-12.01 -1.5,-21.92 -14,-30.56 16.7,2.26 30.3,-1.04 40.8,-10.42 -5.9,12.09 -0.4,22.13 13.9,30.56 -17.3,-3.45 -31,-0.14 -40.7,10.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8065.24,4239.87 c 1.64,-10.09 -2.53,-18.15 -13.05,-24 13.2,2.97 23.67,-0.77 31.99,-9.79 -2.87,10.56 1.31,18.63 13.05,24 -13.04,-2.2 -23.34,1.91 -31.99,9.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4258.15,4292.69 c 4.65,-9.14 3.26,-17.39 -4.75,-24.69 11.4,5.08 22.33,3.41 32.9,-3.56 -5.95,9.36 -4.55,17.62 4.75,24.69 -11.5,-4.33 -22.38,-2.29 -32.9,3.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 290.434,4891.45 c -6.629,-8.02 -15.891,-12.03 -28.032,-11.68 11.856,-3.6 16.528,-10.87 15.563,-21.03 6.101,8.89 15.371,12.9 28.027,11.67 -11.144,4.1 -15.402,11.56 -15.558,21.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5297.16,4804.34 c 4.91,-8.75 3.9,-16.8 -3.55,-24.07 10.84,5.2 21.52,3.85 32.07,-2.67 -6.17,8.94 -5.16,16.99 3.56,24.07 -10.98,-4.48 -21.62,-2.76 -32.08,2.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5713.48,3777.91 c -9.56,-7.13 -20.54,-9.59 -33.07,-6.96 11.17,-5.96 13.64,-14.41 9.28,-24.81 9.29,8.13 20.27,10.59 33.06,6.96 -10.26,6.33 -12.24,14.9 -9.27,24.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6966.01,4904.8 c -11.72,-9.02 -25.34,-12.25 -41.03,-9.16 14.07,-7.27 17.37,-17.76 12.21,-30.79 11.38,10.27 25,13.5 41.03,9.16 -12.96,7.75 -15.65,18.4 -12.21,30.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path238",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6739.02,4428.93 c -9.26,-5.92 -19.88,-5.88 -31.3,-2.29 7.02,-7.6 8.22,-15.43 3.05,-23.49 8.95,6.6 19.5,6.92 31.3,2.29 -8.28,7.6 -9.47,15.43 -3.05,23.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path240",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11451.3,4738.84 c 2,-10.13 -1.9,-18.34 -12.3,-24.44 13.2,3.26 23.9,-0.31 32.6,-9.24 -3.3,10.59 0.7,18.8 12.3,24.45 -13.1,-2.48 -23.6,1.46 -32.6,9.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path242",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6803.08,3719.2 c 2.27,-8.81 -0.74,-16.1 -9.51,-21.74 11.37,3.23 20.9,0.42 28.97,-7.14 -3.4,9.17 -0.38,16.46 9.51,21.74 -11.3,-2.55 -20.7,0.6 -28.97,7.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path244",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11726.8,3824.13 c -11.2,-6.48 -23.6,-5.97 -36.6,-1.29 7.6,-9.14 8.4,-18.28 1.8,-27.42 10.9,7.27 23.1,7.18 36.5,1.29 -9,9.19 -9.8,18.33 -1.7,27.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path246",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6063.25,5300.31 c -16.23,-23.13 -40.77,-35.59 -74.41,-36.39 33.7,-8.22 48.52,-27.63 48.5,-55.84 14.55,25.48 39.11,37.93 74.41,36.39 -31.87,9.68 -45.59,29.68 -48.5,55.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path248",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6410.38,9488.35 c -2.9,-39.14 -26.02,-67.64 -71.22,-84.49 52.79,4.58 89.15,-14.95 112.59,-53.44 -1.35,41.56 21.79,70.04 71.22,84.49 -51.51,-1.73 -86.88,19.13 -112.59,53.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path250",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13941.3,6366.4 c 1.8,-8.5 -1.4,-15.42 -10,-20.61 11,2.82 20,-0.1 27.4,-7.55 -2.8,8.87 0.4,15.79 10.1,20.62 -11,-2.17 -19.8,1.07 -27.5,7.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path252",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13391.8,8706.99 c 4.6,-6.37 4.7,-12.53 -0.3,-18.48 7.7,4.57 16,4.15 24.7,-0.2 -5.6,6.44 -5.7,12.61 0.2,18.49 -7.9,-4.03 -16.1,-3.33 -24.6,0.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path254",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13103.6,8326.77 c -9.5,-10.26 -22.1,-15.1 -38.1,-14.01 15.4,-5.37 20.9,-15.21 18.7,-28.59 8.9,11.45 21.5,16.28 38.1,14.01 -14.4,5.98 -19.3,16.06 -18.7,28.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path256",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13207.8,7718.83 c 1.6,-10.09 -2.6,-18.15 -13.1,-24 13.2,2.97 23.7,-0.77 32,-9.8 -2.9,10.57 1.3,18.64 13.1,24.01 -13.1,-2.2 -23.4,1.91 -32,9.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path258",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13887.8,7607.58 c -11.5,-7.12 -24.6,-6.9 -38.5,-2.28 8.4,-9.47 9.6,-19.11 3,-28.92 11.2,7.95 24.2,8.16 38.6,2.28 -10,9.48 -11.2,19.11 -3.1,28.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path260",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14423.6,7136.42 c -5.8,-5.72 -13.2,-8.26 -22.4,-7.31 8.6,-3.4 11.5,-9.18 9.7,-16.85 5.6,6.42 13,8.95 22.5,7.31 -8.1,3.73 -10.6,9.64 -9.8,16.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path262",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13164.8,6863.83 c 2.2,-7.83 -0.3,-14.38 -8,-19.53 10.1,3.04 18.7,0.66 26,-5.99 -3.2,8.14 -0.7,14.69 8,19.53 -10,-2.42 -18.5,0.26 -26,5.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path264",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13647.1,8356.46 c -1.1,-26.13 -15.9,-45.38 -45.7,-57.14 35.1,3.66 59.7,-8.94 76.1,-34.32 -1.7,27.69 13.1,46.94 45.8,57.13 -34.3,-1.74 -58.3,11.75 -76.2,34.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path266",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14744.7,7797.38 c -4,-25.96 -20.9,-44.22 -51.9,-54.07 35.4,1.45 58.5,-12.65 72.1,-38.97 1.3,27.7 18.2,45.95 51.9,54.07 -34.4,0.41 -56.8,15.35 -72.1,38.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path268",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14113.9,9232.34 c 5.5,-7.98 5.3,-15.61 -1,-22.86 9.7,5.48 19.9,4.78 30.4,-0.79 -6.6,8.09 -6.5,15.72 1.1,22.86 -9.9,-4.81 -20.1,-3.76 -30.5,0.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path270",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13314.2,9282.99 c -9.4,-7.12 -20.2,-9.64 -32.7,-7.13 11.2,-5.82 13.7,-14.17 9.5,-24.51 9.1,8.13 20,10.64 32.7,7.13 -10.3,6.21 -12.3,14.68 -9.5,24.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path272",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8733.59,4402.5 c 0.89,-9.09 -3.3,-16.18 -13.05,-21.07 11.99,2.24 21.14,-1.45 28.08,-9.8 -1.97,9.55 2.23,16.64 13.05,21.07 -11.81,-1.55 -20.79,2.46 -28.08,9.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path274",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3064.51,5340.77 c 1.8,-8.51 -1.4,-15.43 -10.06,-20.62 11.05,2.82 20.07,-0.1 27.48,-7.55 -2.86,8.88 0.34,15.8 10.06,20.62 -10.95,-2.17 -19.83,1.08 -27.48,7.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path276",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7413.35,4751.78 c -8.52,-6.49 -18.02,-8.09 -28.58,-4.45 8.2,-5.82 9.21,-13.17 5.92,-21.43 8.66,5.62 18.16,7.22 28.58,4.45 -9,5.54 -10.43,12.8 -5.92,21.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path278",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6752.78,5749.43 c 1.23,-6.91 -3.21,-12.01 -11.02,-16.02 9.42,0.23 16.61,-2.43 21.36,-8.25 -1.93,7.04 2.17,12.25 11.02,16.02 -9.93,-0.84 -17.12,1.82 -21.36,8.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path280",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2102.7,7144.41 c -5.8,-10.48 -15.76,-16.6 -30.28,-17.95 15.02,-2.56 22.45,-10.51 23.93,-22.72 4.95,11.45 14.92,17.57 30.28,17.95 -14.3,3.24 -21.29,11.49 -23.93,22.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path282",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7036.77,5880.3 c 2.12,-7.1 -0.08,-13.06 -7.01,-17.79 9.11,2.83 16.92,0.72 23.71,-5.26 -3.05,7.37 -0.84,13.33 7.01,17.79 -9.08,-2.27 -16.8,0.11 -23.71,5.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path284",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2950.19,8029.91 c 0.89,-9.08 -3.3,-16.17 -13.05,-21.07 11.99,2.24 21.14,-1.44 28.08,-9.79 -1.97,9.55 2.23,16.63 13.05,21.07 -11.81,-1.55 -20.79,2.46 -28.08,9.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path286",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3495.3,7587.79 c -2.79,-7.02 -8.64,-11.44 -17.84,-13.03 9.86,-0.89 15.34,-5.63 17.37,-13.39 2.16,7.6 8.02,12.02 17.84,13.04 -9.46,1.36 -14.68,6.31 -17.37,13.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path288",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2075.08,8212.98 c 1.8,-8.5 -1.4,-15.42 -10.06,-20.61 11.05,2.82 20.06,-0.1 27.48,-7.55 -2.86,8.88 0.34,15.79 10.06,20.62 -10.96,-2.17 -19.84,1.08 -27.48,7.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path290",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2850.98,8710.41 c 2.24,-7.83 -0.28,-14.38 -7.98,-19.53 10.08,3.04 18.64,0.66 26.02,-5.98 -3.24,8.13 -0.72,14.68 7.98,19.52 -10.03,-2.42 -18.49,0.27 -26.02,5.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path292",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3668.67,8917.68 c -5.67,-11.64 -16.16,-18.66 -31.9,-20.64 16.53,-2.26 25.14,-10.68 27.51,-23.93 4.69,12.66 15.18,19.68 31.9,20.64 -15.8,3.03 -23.94,11.77 -27.51,23.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path294",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1544.95,9044.74 c 2.27,-8.81 -0.74,-16.1 -9.52,-21.74 11.38,3.23 20.9,0.42 28.97,-7.14 -3.39,9.17 -0.38,16.46 9.52,21.74 -11.31,-2.55 -20.71,0.6 -28.97,7.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path296",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8314.11,5815.28 c 4.61,-6.37 4.67,-12.54 -0.26,-18.48 7.71,4.57 15.96,4.15 24.63,-0.2 -5.6,6.44 -5.65,12.61 0.26,18.48 -7.88,-4.03 -16.14,-3.32 -24.63,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path298",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7941.99,6420.09 c -9.48,-10.25 -22.08,-15.09 -38.09,-14.01 15.34,-5.36 20.87,-15.21 18.68,-28.58 8.86,11.44 21.47,16.28 38.09,14.01 -14.37,5.98 -19.32,16.06 -18.68,28.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path300",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10827.4,5616.34 c -5.8,-10.49 -15.8,-16.61 -30.3,-17.96 15,-2.55 22.5,-10.51 24,-22.72 4.9,11.45 14.9,17.57 30.2,17.96 -14.3,3.24 -21.3,11.48 -23.9,22.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path302",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9707.36,7443.25 c -7.78,-9.63 -18.77,-14.51 -33.27,-14.21 14.21,-4.19 19.92,-12.83 18.93,-24.96 7.15,10.67 18.14,15.55 33.28,14.2 -13.38,4.79 -18.59,13.66 -18.94,24.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path304",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7922.81,5285.22 c 1.64,-10.09 -2.53,-18.16 -13.04,-24.01 13.19,2.98 23.66,-0.77 31.98,-9.79 -2.87,10.56 1.31,18.63 13.06,24.01 -13.05,-2.21 -23.35,1.91 -32,9.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path306",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9003.5,5056.76 c -11.57,-7.13 -24.61,-6.9 -38.54,-2.28 8.4,-9.48 9.63,-19.11 3.04,-28.92 11.2,7.95 24.17,8.16 38.54,2.28 -9.95,9.48 -11.17,19.11 -3.04,28.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path308",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11674.9,6501.84 c 0.9,-9.09 -3.3,-16.18 -13.1,-21.08 12,2.24 21.2,-1.44 28.1,-9.79 -1.9,9.55 2.3,16.64 13.1,21.07 -11.8,-1.55 -20.8,2.46 -28.1,9.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path310",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8939.11,5792.64 c -1.13,-26.13 -15.95,-45.38 -45.74,-57.14 35.09,3.66 59.73,-8.94 76.14,-34.32 -1.75,27.69 13.09,46.94 45.74,57.13 -34.3,-1.74 -58.29,11.75 -76.14,34.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path312",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9860.42,5246.56 c -4.03,-25.96 -20.94,-44.22 -51.93,-54.07 35.38,1.45 58.52,-12.65 72.06,-38.97 1.33,27.7 18.26,45.95 51.92,54.07 -34.37,0.41 -56.78,15.35 -72.05,38.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path314",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9969.59,6077.58 c 2.73,-39.15 -16.16,-69.35 -58.69,-89.75 51.83,8.81 90.8,-7.67 119.6,-44.04 -7.3,41.21 11.6,71.4 58.7,89.75 -51,-5.88 -89.1,12 -119.61,44.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path316",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11171.5,7404.33 c 1.8,-8.5 -1.4,-15.42 -10,-20.62 11,2.82 20,-0.1 27.4,-7.54 -2.8,8.87 0.4,15.79 10.1,20.61 -11,-2.17 -19.8,1.08 -27.5,7.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path318",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9229.6,6681.52 c 5.45,-7.98 5.27,-15.61 -1.06,-22.86 9.72,5.48 19.91,4.78 30.46,-0.79 -6.66,8.09 -6.48,15.72 1.06,22.85 -9.91,-4.8 -20.1,-3.75 -30.46,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path320",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7179.69,6942.1 c 2.24,-7.83 -0.27,-14.38 -7.98,-19.53 10.08,3.03 18.65,0.65 26.02,-5.99 -3.24,8.14 -0.72,14.69 7.99,19.53 -10.03,-2.42 -18.5,0.26 -26.03,5.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path322",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4784.05,7335.13 c -9.55,-7.12 -20.53,-9.58 -33.06,-6.96 11.16,-5.95 13.63,-14.4 9.27,-24.81 9.3,8.14 20.28,10.6 33.07,6.96 -10.26,6.34 -12.24,14.91 -9.28,24.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path324",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5873.66,7276.43 c 2.27,-8.81 -0.74,-16.11 -9.52,-21.74 11.38,3.23 20.9,0.42 28.97,-7.14 -3.39,9.17 -0.38,16.46 9.52,21.74 -11.31,-2.55 -20.71,0.6 -28.97,7.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path326",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3996.04,7362.07 c 5.35,-25.83 -4.46,-46.81 -30.83,-62.51 33.58,8.48 60.9,-0.47 83.3,-23.13 -8.56,26.96 1.27,47.94 30.83,62.5 -33.28,-6.48 -60.18,3.44 -83.3,23.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path328",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5272.92,8036.06 c -2.9,-39.14 -26.02,-67.63 -71.22,-84.49 52.79,4.58 89.15,-14.95 112.59,-53.44 -1.35,41.56 21.79,70.05 71.22,84.49 -51.51,-1.73 -86.87,19.12 -112.59,53.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path330",
    style: {
      fill: "#e08c16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9520.33,5727.42 c -71.79,-63.48 -17.12,-242.6 122.12,-400.06 139.23,-157.47 482.65,-283.91 482.65,-283.91 0,0 -83.4,356.33 -222.66,513.8 -139.24,157.46 -310.31,233.65 -382.11,170.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path332",
    style: {
      fill: "#efae50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9520.33,5727.42 c -48.6,-42.98 -11.59,-164.24 82.67,-270.84 94.26,-106.6 326.76,-192.2 326.76,-192.2 0,0 -56.49,241.23 -150.75,347.83 -94.26,106.61 -210.07,158.19 -258.68,115.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path334",
    style: {
      fill: "#f7f68a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9520.33,5727.42 c -35.01,-30.96 -8.35,-118.31 59.56,-195.1 67.9,-76.8 235.38,-138.46 235.38,-138.46 0,0 -40.69,173.78 -108.59,250.57 -67.9,76.79 -151.33,113.95 -186.35,82.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path336",
    style: {
      fill: "#e08c16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9783.62,5960.23 c -71.79,-63.49 -17.12,-242.6 122.11,-400.07 139.27,-157.46 482.67,-283.9 482.67,-283.9 0,0 -83.4,356.33 -222.7,513.79 -139.2,157.47 -310.28,233.66 -382.08,170.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path338",
    style: {
      fill: "#efae50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9783.62,5960.23 c -48.6,-42.98 -11.59,-164.24 82.67,-270.84 94.26,-106.6 326.71,-192.2 326.71,-192.2 0,0 -56.4,241.23 -150.7,347.83 -94.26,106.6 -210.07,158.18 -258.68,115.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path340",
    style: {
      fill: "#f7f68a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9783.62,5960.23 c -35.01,-30.96 -8.35,-118.31 59.56,-195.11 67.9,-76.79 235.42,-138.45 235.42,-138.45 0,0 -40.7,173.77 -108.63,250.57 -67.9,76.79 -151.33,113.94 -186.35,82.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path342",
    style: {
      fill: "#bb1e24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9824.51,6070.23 -155.07,-137.11 39.03,-115.43 23.25,-26.3 c 51.04,26.36 193.27,152.33 225.82,199.68 l -23.25,26.29 -109.78,52.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path344",
    style: {
      fill: "#bb1e24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9567.16,5842.68 -155.06,-137.11 39.02,-115.43 23.25,-26.3 c 44.9,23.05 186.55,147.53 225.82,199.68 l -23.24,26.29 -109.79,52.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path346",
    style: {
      fill: "#d01c2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9646.2,5959.41 62.27,-141.72 c 84,56.68 159.28,123.24 225.82,199.67 l -133.03,79.16 -155.06,-137.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path348",
    style: {
      fill: "#d01c2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9388.85,5731.86 62.27,-141.72 c 84.01,56.68 159.28,123.24 225.83,199.67 l -133.04,79.16 -155.06,-137.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    style: {
      fill: "#d6d8d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7949.18,7776.1 c 0,0 -193.24,-1226.31 1391.46,-2185.26 182.87,200.92 385.2,379.83 607,536.72 C 9144.65,7815.97 7949.18,7776.1 7949.18,7776.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path352",
    style: {
      fill: "#939594",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8732.14,6879.96 c -64.65,-57.17 -163.4,-51.1 -220.57,13.55 -57.16,64.65 -51.09,163.4 13.56,220.56 64.64,57.17 163.4,51.1 220.56,-13.55 57.17,-64.65 51.1,-163.4 -13.55,-220.56 m -264.5,299.13 c -100.56,-88.92 -109.99,-242.51 -21.08,-343.07 88.91,-100.55 242.5,-109.99 343.06,-21.08 100.56,88.91 110,242.51 21.08,343.07 -88.91,100.55 -242.5,109.99 -343.06,21.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path354",
    style: {
      fill: "#2e6ab2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8494.17,7149.09 c -72.45,-64.06 -79.25,-174.72 -15.2,-247.17 64.06,-72.44 174.73,-79.24 247.17,-15.18 72.45,64.06 79.25,174.71 15.19,247.16 -64.06,72.45 -174.72,79.25 -247.16,15.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path356",
    style: {
      fill: "#275d9b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8719.17,6895.14 c -58.94,-52.12 -149.3,-46.56 -201.42,12.38 -52.11,58.94 -46.56,149.3 12.38,201.42 58.95,52.11 149.3,46.56 201.42,-12.38 52.11,-58.94 46.56,-149.3 -12.38,-201.42 m -208.03,235.27 c -70.77,-62.59 -77.44,-171.1 -14.86,-241.88 62.59,-70.78 171.1,-77.45 241.88,-14.86 70.78,62.59 77.45,171.09 14.86,241.88 -62.59,70.78 -171.09,77.45 -241.88,14.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path358",
    style: {
      fill: "#173350",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8704.67,6911.02 c -58.94,-52.12 -149.3,-46.57 -201.41,12.37 -52.12,58.94 -46.57,149.3 12.37,201.42 58.95,52.12 149.3,46.57 201.42,-12.37 52.11,-58.95 46.56,-149.3 -12.38,-201.42 m -208.02,235.26 c -70.78,-62.59 -77.45,-171.09 -14.87,-241.87 62.59,-70.79 171.1,-77.46 241.88,-14.86 70.78,62.58 77.45,171.09 14.86,241.87 -62.59,70.79 -171.09,77.45 -241.87,14.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path360",
    style: {
      fill: "#d01c2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8713.15,6901.43 c -64.65,-57.17 -163.4,-51.1 -220.57,13.55 -57.16,64.65 -51.09,163.4 13.56,220.57 64.65,57.16 163.4,51.1 220.56,-13.56 57.17,-64.65 51.1,-163.39 -13.55,-220.56 m -264.5,299.13 c -100.55,-88.91 -109.99,-242.51 -21.07,-343.06 88.91,-100.56 242.5,-110 343.06,-21.08 100.55,88.91 109.99,242.5 21.08,343.06 -88.92,100.56 -242.51,109.99 -343.07,21.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path362",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8478.19,7149.3 c -4.94,0 -9.86,2.04 -13.39,6.04 -6.53,7.38 -5.84,18.67 1.55,25.2 3.4,3 7.62,4.48 11.83,4.48 4.94,0 9.85,-2.04 13.38,-6.03 6.53,-7.39 5.84,-18.67 -1.55,-25.21 -3.4,-3 -7.61,-4.48 -11.82,-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path364",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8743.24,6849.55 c -4.94,0 -9.86,2.04 -13.39,6.03 -6.53,7.39 -5.84,18.67 1.55,25.21 3.4,3 7.62,4.48 11.82,4.48 4.94,0 9.86,-2.04 13.39,-6.03 6.53,-7.39 5.84,-18.68 -1.55,-25.21 -3.4,-3 -7.62,-4.48 -11.82,-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path366",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8462.16,6869.19 c -4.94,0 -9.85,2.04 -13.38,6.04 -6.53,7.38 -5.84,18.67 1.55,25.2 3.39,3.01 7.62,4.48 11.82,4.48 4.94,0 9.86,-2.04 13.38,-6.03 6.54,-7.39 5.84,-18.67 -1.54,-25.21 -3.4,-3 -7.62,-4.48 -11.83,-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path368",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8759.83,7132.4 c -4.94,0 -9.86,2.03 -13.39,6.02 -6.53,7.39 -5.84,18.68 1.55,25.21 3.4,3.01 7.62,4.48 11.83,4.48 4.93,0 9.85,-2.04 13.38,-6.03 6.53,-7.39 5.84,-18.67 -1.55,-25.21 -3.4,-3 -7.62,-4.47 -11.82,-4.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path370",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8622.71,7199.92 c -0.37,0 -0.74,0.01 -1.11,0.04 -9.84,0.6 -17.33,9.07 -16.72,18.92 0.58,9.47 8.44,16.76 17.81,16.76 0.36,0 0.73,-0.01 1.1,-0.03 9.85,-0.61 17.34,-9.08 16.73,-18.92 -0.58,-9.48 -8.45,-16.77 -17.81,-16.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path372",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8598.18,6800.55 c -0.37,0 -0.74,0.01 -1.12,0.03 -9.84,0.61 -17.33,9.08 -16.72,18.92 0.57,9.47 8.44,16.77 17.8,16.77 0.37,0 0.74,-0.02 1.11,-0.04 9.85,-0.6 17.34,-9.07 16.73,-18.92 -0.58,-9.47 -8.44,-16.76 -17.8,-16.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8413.31,7013.19 c -0.37,0 -0.74,0.01 -1.11,0.03 -9.84,0.61 -17.33,9.08 -16.72,18.92 0.58,9.47 8.44,16.76 17.8,16.76 0.37,0 0.74,-0.01 1.12,-0.03 9.84,-0.61 17.33,-9.07 16.72,-18.92 -0.58,-9.47 -8.44,-16.76 -17.81,-16.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8809.91,6988.82 c -0.37,0 -0.74,0.01 -1.12,0.03 -9.84,0.61 -17.33,9.08 -16.72,18.92 0.58,9.47 8.44,16.77 17.8,16.77 0.37,0 0.74,-0.01 1.12,-0.04 9.84,-0.6 17.33,-9.07 16.72,-18.92 -0.58,-9.47 -8.44,-16.76 -17.8,-16.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path378",
    style: {
      fill: "#939594",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9238.44,6307.36 c -64.65,-57.16 -163.41,-51.1 -220.57,13.56 -57.16,64.64 -51.09,163.39 13.55,220.56 64.65,57.17 163.41,51.1 220.57,-13.55 57.16,-64.65 51.09,-163.4 -13.55,-220.57 m -264.5,299.13 c -100.56,-88.91 -110,-242.51 -21.08,-343.06 88.91,-100.56 242.5,-109.99 343.06,-21.08 100.56,88.91 110,242.5 21.08,343.06 -88.91,100.56 -242.51,110 -343.06,21.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path380",
    style: {
      fill: "#2e6ab2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9000.46,6576.49 c -72.44,-64.05 -79.24,-174.71 -15.18,-247.16 64.05,-72.45 174.71,-79.24 247.16,-15.19 72.45,64.06 79.25,174.72 15.19,247.17 -64.06,72.45 -174.72,79.24 -247.17,15.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path382",
    style: {
      fill: "#275d9b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9225.47,6322.55 c -58.94,-52.12 -149.3,-46.57 -201.42,12.37 -52.11,58.94 -46.56,149.3 12.38,201.42 58.94,52.12 149.3,46.57 201.42,-12.37 52.12,-58.95 46.56,-149.3 -12.38,-201.42 m -208.03,235.26 c -70.78,-62.59 -77.45,-171.09 -14.86,-241.87 62.59,-70.79 171.09,-77.46 241.88,-14.86 70.78,62.58 77.45,171.09 14.86,241.87 -62.59,70.79 -171.09,77.45 -241.88,14.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path384",
    style: {
      fill: "#173350",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9210.97,6338.42 c -58.94,-52.12 -149.3,-46.56 -201.41,12.38 -52.12,58.94 -46.57,149.29 12.37,201.42 58.94,52.12 149.3,46.56 201.42,-12.38 52.12,-58.94 46.56,-149.3 -12.38,-201.42 m -208.02,235.27 c -70.79,-62.59 -77.46,-171.09 -14.87,-241.88 62.59,-70.78 171.09,-77.45 241.88,-14.86 70.78,62.59 77.45,171.09 14.86,241.88 -62.59,70.78 -171.09,77.45 -241.87,14.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path386",
    style: {
      fill: "#d01c2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9219.45,6328.84 c -64.65,-57.17 -163.4,-51.1 -220.56,13.55 -57.17,64.65 -51.1,163.4 13.55,220.56 64.65,57.17 163.4,51.1 220.56,-13.55 57.17,-64.65 51.1,-163.4 -13.55,-220.56 m -264.5,299.13 c -100.56,-88.92 -109.99,-242.51 -21.08,-343.07 88.92,-100.55 242.51,-109.99 343.06,-21.08 100.56,88.91 110,242.51 21.08,343.07 -88.91,100.55 -242.51,109.99 -343.06,21.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path388",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8984.49,6576.71 c -4.94,0 -9.86,2.04 -13.38,6.03 -6.54,7.39 -5.84,18.67 1.54,25.21 3.4,3 7.62,4.48 11.83,4.48 4.93,0 9.85,-2.04 13.38,-6.03 6.53,-7.39 5.84,-18.68 -1.55,-25.21 -3.4,-3 -7.62,-4.48 -11.82,-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path390",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9249.53,6276.96 c -4.93,0 -9.85,2.03 -13.38,6.02 -6.53,7.4 -5.84,18.68 1.55,25.22 3.4,3 7.62,4.47 11.82,4.47 4.94,0 9.86,-2.03 13.39,-6.03 6.53,-7.38 5.84,-18.67 -1.55,-25.2 -3.4,-3.01 -7.62,-4.48 -11.83,-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path392",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8968.46,6296.6 c -4.94,0 -9.85,2.04 -13.38,6.03 -6.53,7.39 -5.84,18.67 1.55,25.21 3.4,3 7.62,4.48 11.82,4.48 4.94,0 9.85,-2.04 13.38,-6.03 6.54,-7.39 5.84,-18.68 -1.55,-25.21 -3.39,-3 -7.61,-4.48 -11.82,-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path394",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9266.13,6559.8 c -4.94,0 -9.86,2.04 -13.39,6.03 -6.53,7.39 -5.84,18.67 1.55,25.21 3.4,3 7.62,4.48 11.82,4.48 4.94,0 9.86,-2.04 13.39,-6.03 6.53,-7.39 5.84,-18.68 -1.55,-25.21 -3.4,-3 -7.62,-4.48 -11.82,-4.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path396",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9129.01,6627.33 c -0.36,0 -0.74,0.01 -1.11,0.03 -9.84,0.61 -17.33,9.08 -16.73,18.92 0.59,9.48 8.45,16.77 17.81,16.77 0.37,0 0.74,-0.02 1.11,-0.04 9.85,-0.6 17.34,-9.07 16.73,-18.92 -0.58,-9.47 -8.44,-16.76 -17.81,-16.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path398",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9104.47,6227.95 c -0.36,0 -0.74,0.01 -1.11,0.04 -9.84,0.6 -17.33,9.08 -16.72,18.92 0.58,9.47 8.44,16.76 17.8,16.76 0.37,0 0.74,-0.01 1.11,-0.03 9.85,-0.61 17.34,-9.08 16.73,-18.92 -0.58,-9.48 -8.44,-16.77 -17.81,-16.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path400",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8919.61,6440.59 c -0.37,0 -0.74,0.02 -1.11,0.04 -9.84,0.6 -17.33,9.07 -16.73,18.92 0.59,9.47 8.45,16.76 17.81,16.76 0.37,0 0.74,-0.01 1.11,-0.03 9.85,-0.61 17.34,-9.08 16.73,-18.92 -0.58,-9.47 -8.44,-16.77 -17.81,-16.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path402",
    style: {
      fill: "#a11b20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9316.2,6416.22 c -0.37,0 -0.74,0.02 -1.11,0.04 -9.84,0.6 -17.33,9.07 -16.73,18.92 0.59,9.47 8.45,16.76 17.81,16.76 0.37,0 0.74,-0.01 1.11,-0.03 9.85,-0.61 17.34,-9.08 16.73,-18.92 -0.58,-9.47 -8.44,-16.77 -17.81,-16.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path404",
    style: {
      fill: "#d01c2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7949.18,7776.1 c 0,0 -51.26,-325.28 115.51,-771.79 l 629.28,556.43 c -422.4,226.11 -744.79,215.36 -744.79,215.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path406",
    style: {
      fill: "#b5b7b5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9947.64,6127.56 c -431.92,758 -917.46,1168.7 -1301.83,1390.6 l 48.16,42.58 c 391,-209.3 867.66,-621.54 1253.67,-1433.18 v 0 M 8169.66,7751.95 c -0.03,0.01 -0.08,0.02 -0.11,0.03 0.06,-0.02 0.05,-0.01 0.11,-0.03 m -22.75,4.29 c -0.06,0.01 -0.12,0.02 -0.18,0.03 0.06,-0.01 0.12,-0.02 0.18,-0.03 m -5.6,1 c -0.03,0.01 -0.08,0.02 -0.11,0.02 0.03,0 0.08,-0.01 0.11,-0.02 m -5.44,0.95 c -0.06,0.01 -0.09,0.02 -0.16,0.03 0.03,-0.01 0.13,-0.02 0.16,-0.03 m -2.73,0.47 c -0.03,0.01 -0.02,0.01 -0.05,0.01 0.03,0 0.03,0 0.05,-0.01 m -1.32,0.23 c -0.08,0.01 -0.12,0.02 -0.19,0.03 0.08,-0.02 0.1,-0.02 0.19,-0.03 m -0.68,0.11 c -0.12,0.02 -0.21,0.04 -0.33,0.06 0.11,-0.02 0.22,-0.04 0.33,-0.06 m -0.61,0.1 c -0.11,0.02 -0.22,0.04 -0.33,0.06 0.12,-0.02 0.21,-0.04 0.33,-0.06 m -0.74,0.13 c -0.04,0.01 -0.04,0.01 -0.07,0.01 l 0.07,-0.01 m -0.62,0.1 c -0.11,0.02 -0.22,0.04 -0.33,0.06 0.09,-0.02 0.24,-0.04 0.33,-0.06 m -0.67,0.12 c -0.12,0.02 -0.21,0.03 -0.34,0.05 0.12,-0.02 0.22,-0.03 0.34,-0.05 m -0.65,0.11 c -0.12,0.02 -0.25,0.04 -0.37,0.06 0.12,-0.02 0.26,-0.05 0.37,-0.06 m -0.67,0.11 c -0.11,0.02 -0.21,0.03 -0.32,0.05 0.12,-0.02 0.2,-0.03 0.32,-0.05 m -0.66,0.11 c -0.1,0.01 -0.2,0.03 -0.31,0.05 0.12,-0.02 0.2,-0.03 0.31,-0.05 m -0.68,0.11 c -0.11,0.02 -0.21,0.04 -0.32,0.05 0.12,-0.02 0.2,-0.03 0.32,-0.05 m -0.62,0.1 c -0.11,0.02 -0.18,0.03 -0.29,0.05 0.09,-0.01 0.2,-0.03 0.29,-0.05 m -1.38,0.23 c -0.04,0.01 -0.09,0.01 -0.13,0.02 0.06,-0.01 0.07,-0.01 0.13,-0.02 m -0.69,0.11 c -0.01,0.01 -0.01,0.01 -0.02,0.01 l 0.02,-0.01 m -0.62,0.11 c -0.04,0 -0.1,0.01 -0.14,0.02 0.06,-0.01 0.08,-0.02 0.14,-0.02 m -1.31,0.21 c -0.06,0.01 -0.16,0.02 -0.21,0.03 0.08,-0.01 0.12,-0.02 0.21,-0.03 m -0.59,0.09 c -0.19,0.04 -0.37,0.07 -0.56,0.1 0.2,-0.04 0.36,-0.06 0.56,-0.1 m -0.58,0.1 c -0.18,0.03 -0.35,0.06 -0.53,0.08 0.17,-0.02 0.36,-0.05 0.53,-0.08 m -0.71,0.11 c -0.14,0.03 -0.3,0.05 -0.45,0.08 0.17,-0.03 0.28,-0.05 0.45,-0.08 m -0.63,0.11 c -0.13,0.02 -0.27,0.04 -0.4,0.06 0.14,-0.02 0.26,-0.04 0.4,-0.06 m -0.7,0.11 c -0.1,0.01 -0.22,0.03 -0.32,0.05 0.11,-0.02 0.21,-0.03 0.32,-0.05 m -0.63,0.1 c -0.12,0.02 -0.2,0.03 -0.32,0.05 0.08,-0.01 0.23,-0.04 0.32,-0.05 m -0.68,0.11 c -0.09,0.01 -0.19,0.03 -0.27,0.04 0.08,-0.01 0.19,-0.03 0.27,-0.04 m -0.6,0.09 c -0.12,0.02 -0.23,0.04 -0.34,0.06 0.11,-0.02 0.23,-0.04 0.34,-0.06 m -0.67,0.11 c -0.13,0.02 -0.27,0.04 -0.4,0.06 0.11,-0.02 0.29,-0.04 0.4,-0.06 m -0.57,0.09 c -0.15,0.02 -0.29,0.04 -0.43,0.07 0.14,-0.03 0.29,-0.05 0.43,-0.07 m -0.71,0.11 c -0.12,0.02 -0.21,0.03 -0.33,0.05 0.11,-0.01 0.22,-0.03 0.33,-0.05 m -0.61,0.1 c -0.13,0.02 -0.26,0.04 -0.39,0.06 0.14,-0.02 0.25,-0.04 0.39,-0.06 m -0.64,0.1 c -0.16,0.02 -0.32,0.05 -0.48,0.07 0.14,-0.02 0.34,-0.05 0.48,-0.07 m -0.58,0.09 c -0.14,0.02 -0.31,0.05 -0.45,0.07 0.13,-0.02 0.32,-0.05 0.45,-0.07 m -0.73,0.11 c -0.09,0.02 -0.17,0.03 -0.25,0.04 0.08,-0.01 0.16,-0.03 0.25,-0.04 m -0.63,0.1 c -0.12,0.02 -0.22,0.03 -0.34,0.05 0.11,-0.02 0.22,-0.03 0.34,-0.05 m -0.59,0.09 c -0.37,0.06 -0.74,0.12 -1.11,0.17 0.35,-0.05 0.75,-0.11 1.11,-0.17 m -1.23,0.19 c -0.19,0.03 -0.37,0.06 -0.55,0.09 0.16,-0.03 0.39,-0.06 0.55,-0.09 m -0.59,0.09 c -0.2,0.03 -0.4,0.06 -0.6,0.09 0.19,-0.03 0.41,-0.06 0.6,-0.09 m -0.63,0.1 c -0.38,0.06 -0.79,0.12 -1.18,0.18 0.42,-0.07 0.77,-0.12 1.18,-0.18 m -1.3,0.2 c -0.18,0.02 -0.35,0.05 -0.54,0.08 0.2,-0.03 0.35,-0.06 0.54,-0.08 m -0.58,0.08 c -0.2,0.03 -0.39,0.06 -0.59,0.09 0.19,-0.02 0.4,-0.06 0.59,-0.09 m -0.62,0.1 c -0.4,0.06 -0.77,0.11 -1.17,0.17 0.38,-0.05 0.79,-0.11 1.17,-0.17 m -1.3,0.19 c -0.17,0.03 -0.34,0.05 -0.51,0.08 0.17,-0.02 0.35,-0.05 0.51,-0.08 m -0.59,0.09 c -0.17,0.03 -0.37,0.06 -0.54,0.08 0.17,-0.02 0.38,-0.05 0.54,-0.08 m -0.62,0.1 c -0.18,0.02 -0.37,0.05 -0.56,0.08 0.19,-0.03 0.37,-0.06 0.56,-0.08 m -0.6,0.08 c -0.19,0.03 -0.37,0.06 -0.55,0.09 0.19,-0.03 0.36,-0.06 0.55,-0.09 m -0.65,0.1 c -0.17,0.03 -0.34,0.05 -0.51,0.08 0.16,-0.03 0.34,-0.05 0.51,-0.08 m -0.6,0.09 c -0.19,0.03 -0.37,0.05 -0.57,0.08 0.19,-0.02 0.38,-0.05 0.57,-0.08 m -0.59,0.09 c -0.39,0.06 -0.78,0.11 -1.17,0.17 0.4,-0.06 0.76,-0.11 1.17,-0.17 m -1.26,0.18 c -0.18,0.03 -0.37,0.06 -0.55,0.08 0.19,-0.02 0.36,-0.05 0.55,-0.08 m -0.59,0.09 c -0.6,0.09 -1.18,0.17 -1.77,0.26 0.58,-0.09 1.18,-0.18 1.77,-0.26 m -1.85,0.27 c -0.38,0.05 -0.76,0.11 -1.14,0.16 0.4,-0.06 0.73,-0.1 1.14,-0.16 m -1.2,0.17 c -0.39,0.06 -0.75,0.11 -1.14,0.16 0.4,-0.05 0.74,-0.1 1.14,-0.16 m -1.24,0.18 c -0.79,0.11 -1.54,0.22 -2.32,0.33 0.76,-0.11 1.55,-0.22 2.32,-0.33 m -2.38,0.34 c -1.59,0.22 -3.14,0.44 -4.7,0.65 1.55,-0.21 3.12,-0.43 4.7,-0.65 m -4.76,0.66 c -0.18,0.03 -0.35,0.05 -0.52,0.07 0.15,-0.02 0.36,-0.05 0.52,-0.07 m -0.59,0.08 c -0.77,0.11 -1.53,0.21 -2.29,0.31 0.77,-0.1 1.51,-0.2 2.29,-0.31 m -2.33,0.32 c -0.58,0.08 -1.16,0.16 -1.73,0.23 0.57,-0.07 1.16,-0.15 1.73,-0.23 m -1.73,0.23 c -0.19,0.03 -0.36,0.05 -0.54,0.08 0.18,-0.03 0.36,-0.05 0.54,-0.08 m -0.62,0.09 c -1.33,0.17 -2.64,0.35 -3.94,0.52 1.3,-0.17 2.61,-0.35 3.94,-0.52 m -4.13,0.54 c -0.13,0.02 -0.28,0.04 -0.41,0.05 0.12,-0.01 0.28,-0.03 0.41,-0.05 m -0.47,0.06 c -1.32,0.17 -2.63,0.34 -3.93,0.51 1.29,-0.17 2.62,-0.34 3.93,-0.51 m -3.95,0.51 c -0.18,0.02 -0.36,0.05 -0.54,0.07 0.18,-0.02 0.37,-0.05 0.54,-0.07 m -0.55,0.07 c -42.13,5.33 -74.63,7.37 -95.71,8.12 21.08,-0.75 53.57,-2.78 95.71,-8.12 m -95.75,8.12 c -2.24,0.08 -4.35,0.14 -6.33,0.2 1.98,-0.06 4.09,-0.12 6.33,-0.2 m -6.35,0.2 c -0.99,0.02 -1.94,0.05 -2.86,0.07 0.91,-0.02 1.88,-0.05 2.86,-0.07 m -2.89,0.07 c -0.07,0 -0.14,0 -0.21,0 0.07,0 0.14,0 0.21,0 m -0.21,0 c -0.08,0 -0.14,0 -0.21,0.01 0.07,-0.01 0.14,-0.01 0.21,-0.01 m -0.28,0.01 c -0.04,0 -0.1,0 -0.15,0 0.05,0 0.1,0 0.15,0 m -0.23,0 c -0.04,0 -0.09,0 -0.13,0 0.04,0 0.09,0 0.13,0 m -0.23,0.01 c -0.12,0 -0.24,0 -0.36,0 0.13,0 0.23,0 0.36,0 m -0.47,0.01 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.08,0 0.12,0 m -0.19,0 c -0.05,0 -0.11,0 -0.16,0 0.05,0 0.11,0 0.16,0 m -0.21,0 c -0.13,0.01 -0.27,0.01 -0.4,0.01 0.13,0 0.27,0 0.4,-0.01 m -0.42,0.01 c -0.13,0 -0.28,0.01 -0.41,0.01 0.13,0 0.28,-0.01 0.41,-0.01 m -0.45,0.01 c -1.14,0.02 -2.21,0.03 -3.23,0.05 1.02,-0.02 2.08,-0.03 3.23,-0.05 m -3.23,0.05 c -0.38,0 -0.75,0.01 -1.11,0.01 0.35,0 0.73,-0.01 1.11,-0.01 m -9.75,0.01 c 1.1,0.01 2.48,0.02 4.17,0.02 0.35,0 0.73,0 1.1,0 -0.38,0 -0.75,0 -1.1,0 -1.68,0 -3.07,-0.01 -4.17,-0.02 m 8.5,0 c -0.01,0 -0.03,0 -0.04,0 0.01,0 0.03,0 0.04,0 m -0.35,0 c -0.08,0 -0.17,0 -0.25,0.01 0.08,-0.01 0.17,-0.01 0.25,-0.01 m -0.3,0.01 c -0.1,0 -0.2,0 -0.3,0 0.1,0 0.2,0 0.3,0 m -0.34,0 c -0.36,0 -0.71,0 -1.06,0.01 0.35,-0.01 0.7,-0.01 1.06,-0.01 m -1.21,0.01 c -0.18,0 -0.35,0 -0.53,0 0.17,0 0.36,0 0.53,0 m -0.63,0 c -0.1,0 -0.19,0 -0.29,0 0.1,0 0.19,0 0.29,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path408",
    style: {
      fill: "#b11b2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8645.81,7518.16 c -404.29,233.41 -696.63,257.94 -696.63,257.94 0,0 1.01,0.03 2.98,0.06 1.1,0.01 2.49,0.02 4.17,0.02 0.35,0 0.72,0 1.1,0 0.04,0 0.07,0 0.11,0 0.1,0 0.19,0 0.29,0 0.04,0 0.07,0 0.1,0 0.18,0 0.35,0 0.53,0 0.05,0 0.1,0 0.15,0 0.35,-0.01 0.7,-0.01 1.06,-0.01 0.02,0 0.02,0 0.04,0 0.1,0 0.2,0 0.3,0 0.02,0 0.04,0 0.05,0 0.08,-0.01 0.17,-0.01 0.25,-0.01 0.11,0 0.2,0 0.31,0 0.01,0 0.03,0 0.04,0 0.05,0 0.09,0 0.14,0 0.36,0 0.73,-0.01 1.11,-0.01 v 0 c 1.02,-0.02 2.09,-0.03 3.23,-0.05 0.01,0 0.03,0 0.04,0 0.13,0 0.28,-0.01 0.41,-0.01 0.01,0 0.01,0 0.02,0 0.13,0 0.27,0 0.4,-0.01 0.02,0 0.03,0 0.05,0 0.05,0 0.11,0 0.16,0 0.03,0 0.04,0 0.07,0 0.04,0 0.08,0 0.12,0 0.03,0 0.08,-0.01 0.11,-0.01 0.12,0 0.24,0 0.36,0 0.03,0 0.07,0 0.1,-0.01 0.04,0 0.09,0 0.13,0 0.03,0 0.05,0 0.08,0 0.05,0 0.11,0 0.15,0 0.02,0 0.05,0 0.07,0 0.07,-0.01 0.13,-0.01 0.21,-0.01 v 0 c 0.07,0 0.14,0 0.21,0 0.01,0 0.02,0 0.03,0 0.92,-0.02 1.87,-0.05 2.86,-0.07 0.01,0 0.01,0 0.02,0 1.98,-0.06 4.09,-0.12 6.33,-0.2 0.01,0 0.02,0 0.04,0 21.08,-0.75 53.58,-2.79 95.71,-8.12 h 0.01 c 0.18,-0.02 0.36,-0.05 0.54,-0.07 0.03,0 0,0 0.02,0 1.3,-0.17 2.61,-0.34 3.93,-0.51 0.02,0 0.03,0 0.06,-0.01 0.13,-0.01 0.28,-0.03 0.41,-0.05 0.07,-0.01 0.11,-0.01 0.19,-0.02 1.3,-0.17 2.61,-0.35 3.94,-0.52 0.02,-0.01 0.05,-0.01 0.08,-0.01 0.18,-0.03 0.35,-0.05 0.54,-0.08 v 0 c 0.57,-0.07 1.15,-0.15 1.73,-0.23 0.02,0 0.01,0 0.04,-0.01 0.76,-0.1 1.52,-0.2 2.29,-0.31 0.02,0 0.04,0 0.07,-0.01 0.17,-0.02 0.34,-0.04 0.52,-0.07 0.02,0 0.03,0 0.06,-0.01 1.56,-0.21 3.11,-0.43 4.7,-0.65 0.02,-0.01 0.03,-0.01 0.06,-0.01 0.78,-0.11 1.53,-0.22 2.32,-0.33 0.02,0 0.07,-0.01 0.1,-0.02 0.39,-0.05 0.75,-0.1 1.14,-0.16 l 0.06,-0.01 c 0.38,-0.05 0.76,-0.11 1.14,-0.16 0.02,-0.01 0.05,-0.01 0.08,-0.01 0.59,-0.09 1.17,-0.17 1.77,-0.26 l 0.04,-0.01 c 0.18,-0.02 0.37,-0.05 0.55,-0.08 0.03,0 0.06,-0.01 0.09,-0.01 0.39,-0.06 0.78,-0.11 1.17,-0.17 l 0.02,-0.01 c 0.2,-0.03 0.38,-0.05 0.57,-0.08 0.03,0 0.06,-0.01 0.09,-0.01 0.17,-0.03 0.34,-0.05 0.51,-0.08 0.02,0 0.07,-0.01 0.1,-0.01 0.18,-0.03 0.36,-0.06 0.55,-0.09 0.03,0 0.02,0 0.04,0 0.19,-0.03 0.38,-0.06 0.56,-0.08 0.03,-0.01 0.06,-0.01 0.08,-0.02 0.17,-0.02 0.37,-0.05 0.54,-0.08 0.03,0 0.06,-0.01 0.08,-0.01 0.17,-0.03 0.34,-0.05 0.51,-0.08 0.06,0 0.07,-0.01 0.13,-0.02 0.4,-0.06 0.77,-0.11 1.17,-0.17 0.03,-0.01 0,0 0.03,-0.01 0.2,-0.03 0.39,-0.06 0.59,-0.09 h 0.04 c 0.19,-0.03 0.36,-0.06 0.54,-0.08 0.03,-0.01 0.1,-0.02 0.12,-0.02 0.39,-0.06 0.8,-0.12 1.18,-0.18 l 0.03,-0.01 c 0.2,-0.03 0.4,-0.06 0.6,-0.09 0.03,0 0.01,0 0.04,0 0.18,-0.03 0.36,-0.06 0.55,-0.09 0.06,-0.01 0.06,-0.01 0.12,-0.02 0.37,-0.05 0.74,-0.11 1.11,-0.17 0.09,-0.01 0.17,-0.03 0.25,-0.04 0.12,-0.02 0.22,-0.03 0.34,-0.05 0.13,-0.02 0.24,-0.04 0.38,-0.06 0.08,-0.01 0.16,-0.02 0.25,-0.04 0.08,-0.01 0.19,-0.03 0.28,-0.04 0.14,-0.02 0.31,-0.05 0.45,-0.07 0.06,-0.01 0.04,-0.01 0.1,-0.02 0.16,-0.02 0.32,-0.05 0.48,-0.07 0.09,-0.02 0.17,-0.03 0.25,-0.04 0.13,-0.02 0.26,-0.04 0.39,-0.06 0.09,-0.02 0.19,-0.03 0.28,-0.05 0.12,-0.02 0.21,-0.03 0.33,-0.05 0.11,-0.02 0.17,-0.03 0.28,-0.04 0.14,-0.03 0.28,-0.05 0.43,-0.07 0.06,-0.01 0.11,-0.02 0.17,-0.03 0.13,-0.02 0.27,-0.04 0.4,-0.06 0.11,-0.02 0.21,-0.04 0.33,-0.05 0.11,-0.02 0.22,-0.04 0.34,-0.06 0.11,-0.02 0.21,-0.03 0.33,-0.05 0.08,-0.01 0.18,-0.03 0.27,-0.04 0.14,-0.03 0.22,-0.04 0.36,-0.06 0.12,-0.02 0.2,-0.03 0.32,-0.05 0.11,-0.02 0.2,-0.03 0.31,-0.05 0.1,-0.02 0.22,-0.04 0.32,-0.05 0.08,-0.02 0.22,-0.04 0.3,-0.05 0.13,-0.02 0.27,-0.04 0.4,-0.06 0.06,-0.01 0.13,-0.03 0.18,-0.03 0.15,-0.03 0.31,-0.05 0.45,-0.08 0.06,-0.01 0.12,-0.02 0.18,-0.03 0.18,-0.02 0.35,-0.05 0.53,-0.08 h 0.02 c 0.19,-0.03 0.37,-0.06 0.56,-0.1 0.12,-0.01 0.26,-0.04 0.38,-0.06 0.05,-0.01 0.15,-0.02 0.21,-0.03 0.37,-0.06 0.8,-0.13 1.17,-0.19 0.04,-0.01 0.1,-0.02 0.14,-0.02 0.2,-0.04 0.4,-0.07 0.6,-0.1 0.01,0 0.01,0 0.02,-0.01 0.17,-0.02 0.39,-0.06 0.56,-0.09 0.04,-0.01 0.09,-0.01 0.13,-0.02 0.37,-0.06 0.72,-0.12 1.09,-0.18 0.11,-0.02 0.18,-0.03 0.29,-0.05 0.09,-0.01 0.22,-0.03 0.3,-0.05 0.11,-0.01 0.21,-0.03 0.32,-0.05 0.11,-0.02 0.26,-0.04 0.37,-0.06 0.11,-0.02 0.21,-0.04 0.31,-0.05 0.12,-0.02 0.22,-0.04 0.34,-0.06 0.11,-0.02 0.21,-0.03 0.32,-0.05 0.08,-0.02 0.22,-0.04 0.3,-0.05 0.12,-0.02 0.25,-0.04 0.37,-0.06 0.12,-0.02 0.2,-0.04 0.31,-0.06 0.13,-0.02 0.22,-0.03 0.34,-0.05 0.11,-0.02 0.23,-0.04 0.34,-0.06 0.11,-0.02 0.22,-0.04 0.33,-0.06 0.2,-0.03 0.34,-0.05 0.55,-0.09 0.03,0 0.03,0 0.07,-0.01 0.14,-0.02 0.27,-0.04 0.41,-0.07 0.11,-0.02 0.22,-0.04 0.33,-0.06 0.09,-0.01 0.19,-0.03 0.28,-0.04 0.12,-0.02 0.21,-0.04 0.33,-0.06 0.15,-0.02 0.34,-0.06 0.49,-0.08 0.07,-0.01 0.11,-0.02 0.19,-0.03 0.41,-0.07 0.85,-0.15 1.27,-0.22 0.03,0 0.02,0 0.05,-0.01 0.86,-0.15 1.72,-0.29 2.57,-0.44 0.07,-0.01 0.1,-0.02 0.16,-0.03 1.77,-0.3 3.53,-0.61 5.33,-0.93 0.03,0 0.08,-0.01 0.11,-0.02 1.79,-0.32 3.6,-0.64 5.42,-0.97 0.06,-0.01 0.12,-0.02 0.18,-0.03 7.37,-1.33 14.92,-2.75 22.64,-4.26 0.03,-0.01 0.08,-0.02 0.11,-0.03 132.9,-26.06 316.54,-80 524.31,-191.21 l -48.16,-42.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path410",
    style: {
      fill: "#b5b7b5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 9340.64,5590.84 C 8067,6361.56 7941.82,7304.98 7941.75,7645.65 c -0.01,63.36 4.3,105.87 6.36,122.55 -6.44,-52.22 -35.03,-357.96 116.58,-763.89 l 52.27,46.22 c 171.97,-419.24 519.91,-960.85 1223.68,-1459.69 M 7948.11,7768.21 c 0.06,0.44 0.11,0.87 0.16,1.28 -0.05,-0.41 -0.1,-0.83 -0.16,-1.28 m 0.17,1.28 c 0.07,0.61 0.15,1.19 0.22,1.71 -0.07,-0.52 -0.15,-1.09 -0.22,-1.71 m 0.22,1.73 c 0.06,0.47 0.12,0.91 0.17,1.31 -0.05,-0.4 -0.11,-0.84 -0.17,-1.31 m 0.18,1.37 c 0.01,0.1 0.03,0.21 0.04,0.3 -0.01,-0.09 -0.03,-0.2 -0.04,-0.3 m 0.05,0.34 c 0.13,0.99 0.24,1.75 0.32,2.28 -0.08,-0.53 -0.19,-1.29 -0.32,-2.28 m 0.32,2.28 c 0.01,0.07 0.02,0.14 0.03,0.2 -0.01,-0.06 -0.02,-0.13 -0.03,-0.2 m 0.03,0.23 c 0.01,0.05 0.02,0.1 0.02,0.15 0,-0.05 -0.01,-0.1 -0.02,-0.15 m 0.03,0.18 c 0,0.02 0,0.04 0.01,0.06 -0.01,-0.02 -0.01,-0.04 -0.01,-0.06 m 0.01,0.08 c 0.01,0.04 0.01,0.08 0.02,0.12 -0.01,-0.04 -0.01,-0.08 -0.02,-0.12 m 0.02,0.14 c 0,0.01 0,0.02 0.01,0.03 -0.01,-0.01 -0.01,-0.02 -0.01,-0.03 m 0.01,0.04 c 0,0.02 0,0.03 0,0.05 0,-0.02 0,-0.03 0,-0.05 m 0.02,0.13 v 0 0 m 0.01,0.07 c 0,0.01 0,0.02 0,0.02 0,0 0,-0.01 0,-0.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path412",
    style: {
      fill: "#b11b2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8064.69,7004.31 c -151.61,405.93 -123.02,711.67 -116.58,763.89 0,0 0,0 0,0.01 0.06,0.45 0.11,0.87 0.16,1.28 0.01,0.01 0,0 0.01,0 0.07,0.62 0.15,1.19 0.22,1.71 0,0.01 0,0.01 0,0.02 0.06,0.47 0.12,0.91 0.17,1.31 0,0.02 0.01,0.04 0.01,0.06 0.01,0.1 0.03,0.21 0.04,0.3 0,0.02 0,0.03 0.01,0.04 0.13,0.99 0.24,1.75 0.32,2.28 v 0 c 0.01,0.07 0.02,0.14 0.03,0.2 0,0.01 0,0.02 0,0.03 0.01,0.05 0.02,0.1 0.02,0.15 0.01,0.01 0.01,0.02 0.01,0.03 0,0.02 0,0.04 0.01,0.06 0,0.01 0,0.01 0,0.02 0.01,0.04 0.01,0.08 0.02,0.12 0,0.01 0,0.01 0,0.02 0,0.01 0,0.02 0.01,0.03 0,0.01 0,0.01 0,0.01 0,0.02 0,0.03 0,0.05 0.01,0.03 0.01,0.05 0.02,0.08 v 0 c 0,0.03 0.01,0.06 0.01,0.07 0,0.01 0,0.02 0,0.02 v 0 c 0,0 -6.93,-299.63 167.78,-725.57 l -52.27,-46.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path414",
    style: {
      fill: "#bb1e24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8828.16,6051.02 -23.32,-9.69 c 0,0 28.37,-277.22 65.41,-364.26 37.03,-87.04 167,-188.87 167,-188.87 l 372.75,-286.44 23.31,9.69 -151.53,498.67 -453.62,340.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path416",
    style: {
      fill: "#d01c2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8828.16,6051.02 c 0,0 28.37,-277.22 65.41,-364.26 37.03,-87.04 167,-188.87 167,-188.87 l 372.74,-286.44 -128.21,508.36 -476.94,331.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path418",
    style: {
      fill: "#bb1e24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9909.06,6595.61 c -81.85,47.41 -353.51,109.51 -353.51,109.51 l -12.47,-21.95 282.8,-491.95 476.32,-211.45 12.5,21.96 -238.6,405.01 c 0,0 -85.19,141.46 -167.04,188.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path420",
    style: {
      fill: "#d01c2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9896.59,6573.66 c -81.85,47.41 -353.51,109.51 -353.51,109.51 l 270.32,-513.9 488.8,-189.5 -238.6,405.02 c 0,0 -85.16,141.46 -167.01,188.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path422",
    style: {
      fill: "#d2f0fa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11144.2,2844.78 c -5,19.89 -10.4,41.4 -16.3,64.39 -5.8,22.98 -12,47.44 -18.5,73.23 -6.9,25.69 -14.8,52.5 -22.7,80.6 -8.2,28.02 -16,57.4 -25.3,87.46 -9.5,30.03 -19.2,61.06 -29.2,92.97 -5.1,15.94 -10,32.18 -15.4,48.46 -5.6,16.23 -11.2,32.66 -16.9,49.27 -11.4,33.19 -23,67.19 -35.3,101.51 -25.9,68.24 -51.5,139.18 -81.2,209.86 -28,71.34 -60.2,142.24 -91.2,213.65 -33.5,70.29 -65.8,141.17 -101.1,209.18 -33.8,68.81 -70.4,134.77 -104.8,199.1 -17.7,31.9 -35.8,62.9 -53.3,93.35 -8.8,15.21 -17.5,30.26 -26,45.12 -8.7,14.79 -17.8,29.14 -26.5,43.43 -17.4,28.52 -34.4,56.27 -50.9,83.1 -16.5,26.76 -33.5,51.99 -49.2,76.55 -16,24.43 -31,48.05 -45.8,70.13 -15.2,21.86 -29.6,42.61 -43.1,62.1 -13.5,19.49 -26.1,37.72 -37.8,54.59 -11.8,16.78 -23.2,31.8 -33.1,45.58 -40.3,54.89 -63.3,86.26 -63.3,86.26 0,0 22.5,-31.72 61.9,-87.24 9.8,-13.93 20.9,-29.13 32.4,-46.09 11.5,-17.04 23.8,-35.46 37,-55.15 13.2,-19.68 27.2,-40.62 42,-62.7 14.3,-22.39 29.3,-45.94 45,-70.51 15.6,-24.68 32.3,-50.02 48.6,-76.9 16.2,-26.95 32.9,-54.81 50.1,-83.45 8.5,-14.35 17.5,-28.75 26,-43.6 8.4,-14.92 17,-30.02 25.6,-45.29 17.1,-30.62 35.2,-61.54 52.8,-93.46 34.2,-64.34 70.5,-130.3 104.1,-199.1 35.1,-68 67.1,-138.87 100.3,-209.14 31.1,-71.22 63.5,-141.89 91.7,-213.04 29.8,-70.48 55.6,-141.23 81.6,-209.31 12.5,-34.2 23.9,-68.19 35.8,-101.2 5.8,-16.54 11.6,-32.9 17.3,-49.06 5.5,-16.21 10.5,-32.38 15.7,-48.25 10.3,-31.78 20.3,-62.7 30,-92.6 9.6,-29.95 17.7,-59.23 26.1,-87.15 8.2,-27.98 16,-54.79 23.5,-80.3 6.9,-25.66 13.5,-50 19.6,-72.87 6.2,-22.88 12,-44.3 17.3,-64.1 5.2,-19.83 9.4,-38.21 13.4,-54.73 16,-66.16 25.1,-103.97 25.1,-103.97 0,0 -8.5,37.95 -23.4,104.36 -3.8,16.59 -7.7,35.04 -12.6,54.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path424",
    style: {
      fill: "#d2f0fa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10484.9,3256.8 c -5.3,18.17 -11,37.81 -17.1,58.8 -6.2,21 -12.7,43.34 -19.5,66.89 -7.4,23.42 -15.1,48.03 -23.1,73.71 -8.2,25.65 -16.3,52.49 -25.4,80.03 -9.3,27.52 -18.8,55.97 -28.6,85.21 -9.6,29.32 -20.1,59.21 -31,89.7 -10.9,30.51 -21.9,61.7 -33.6,93.28 -23.9,62.9 -48,128.16 -74.7,193.59 -25.7,65.84 -54.1,131.76 -81.8,197.99 -29.4,65.53 -57.9,131.41 -88.3,195.21 -29.4,64.27 -60.5,126.49 -89.99,187 -15.05,30.09 -30.24,59.49 -45.05,88.29 -14.74,28.84 -29.32,56.97 -44.13,84.04 -14.61,27.16 -28.82,53.58 -42.57,79.14 -13.83,25.51 -27.83,49.81 -40.92,73.33 -13.22,23.44 -25.89,45.91 -37.94,67.28 -12.47,21.12 -24.3,41.17 -35.41,60 -11.12,18.83 -21.52,36.46 -31.14,52.75 -9.86,16.14 -18.93,30.97 -27.12,44.36 -32.87,53.49 -51.66,84.05 -51.66,84.05 0,0 18.26,-30.88 50.23,-84.91 7.96,-13.53 16.77,-28.51 26.36,-44.81 9.34,-16.45 19.44,-34.24 30.23,-53.25 10.79,-19.01 22.27,-39.23 34.37,-60.55 11.81,-21.49 24.22,-44.07 37.18,-67.64 12.86,-23.63 26.62,-48.04 40.18,-73.66 13.5,-25.67 27.45,-52.2 41.79,-79.48 14.53,-27.18 28.83,-55.42 43.28,-84.37 14.56,-28.89 29.44,-58.41 44.57,-88.43 29.24,-60.53 60.04,-122.78 89.24,-187.07 30.2,-63.82 58.5,-129.71 87.6,-195.25 27.8,-66.07 56.5,-131.82 82.4,-197.5 26.8,-65.27 51.1,-130.37 75.2,-193.13 11.5,-31.58 22.9,-62.63 34,-93.02 11.2,-30.36 22,-60.12 31.8,-89.31 10.1,-29.13 19.9,-57.46 29.4,-84.87 9.3,-27.43 17.7,-54.17 26.1,-79.71 8.4,-25.58 16.3,-50.1 23.9,-73.42 7.2,-23.41 14.1,-45.63 20.6,-66.5 6.5,-20.88 12.5,-40.42 18.1,-58.49 5.3,-18.15 10.2,-34.83 14.6,-49.88 17.6,-60.3 27.6,-94.75 27.6,-94.75 0,0 -9.5,34.62 -25.9,95.21 -4.2,15.13 -8.8,31.89 -13.8,50.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path426",
    style: {
      fill: "#d2f0fa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12515.3,4071.66 c -19.2,7.16 -40,14.9 -62.2,23.18 -22.2,8.27 -45.8,17.07 -70.7,26.34 -24.7,9.82 -50.7,20.14 -77.8,30.91 -27,10.95 -55.4,21.74 -84.3,34.03 -28.9,12.42 -58.7,25.26 -89.4,38.46 -15.3,6.66 -31,13.14 -46.6,20.19 -15.6,7.19 -31.3,14.46 -47.2,21.81 -31.8,14.85 -64.6,29.34 -97.5,45 -65.3,32.23 -133.4,64.52 -200.8,100.77 -68.2,34.67 -135.5,73.52 -203.6,111.12 -66.8,39.6 -134.4,78.03 -198.9,119.31 -65.3,39.78 -127.6,82.11 -188.5,122.17 -30.2,20.44 -59.3,41.36 -88.2,61.24 -14.4,10.01 -28.6,19.91 -42.7,29.7 -14,9.9 -27.5,20.1 -41,29.94 -26.9,19.79 -53.1,39.03 -78.4,57.65 -25.2,18.72 -48.9,37.75 -72,55.51 -23,17.91 -45.1,35.08 -66.1,51.41 -20.6,16.78 -40.1,32.7 -58.5,47.66 -18.3,14.96 -35.5,28.96 -51.4,41.91 -15.9,13.06 -30,25.57 -42.9,36.59 -51.6,44.38 -81.1,69.73 -81.1,69.73 0,0 29.1,-25.81 80,-70.99 12.8,-11.22 26.7,-23.95 42.3,-37.25 15.7,-13.21 32.7,-27.48 50.8,-42.74 18.2,-15.26 37.5,-31.5 57.8,-48.62 20.6,-16.82 42.8,-33.94 65.6,-52.11 23,-17.98 46.5,-37.24 71.6,-56.21 25.2,-18.86 51.3,-38.35 78,-58.4 13.5,-9.96 26.9,-20.3 40.8,-30.34 14,-9.92 28.2,-19.96 42.5,-30.11 28.7,-20.24 57.9,-41.13 88,-61.73 60.9,-40.29 123.1,-82.87 188.5,-122.9 64.4,-41.53 132,-80.23 198.9,-120.09 68.2,-37.51 135.8,-76.19 204.2,-110.73 67.6,-36.1 135.9,-68.25 201.4,-100.32 33,-15.54 65.8,-30.15 97.8,-44.64 16,-7.22 31.8,-14.36 47.5,-21.42 15.7,-6.92 31.4,-13.28 46.8,-19.81 30.8,-12.94 60.8,-25.53 89.8,-37.7 29.1,-12.05 57.6,-22.6 84.8,-33.33 27.2,-10.49 53.2,-20.89 78.1,-30.16 25.1,-8.89 48.8,-17.32 71.2,-25.25 22.3,-7.93 43.2,-15.34 62.6,-22.2 19.4,-6.73 37.4,-12.27 53.5,-17.62 64.8,-21.04 101.8,-33.05 101.8,-33.05 0,0 -36.8,12.6 -101.2,34.64 -16.1,5.6 -34,11.42 -53.3,18.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path428",
    style: {
      fill: "#d2f0fa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12181,4769.72 c -17.5,7.26 -36.4,15.11 -56.6,23.49 -20.1,8.39 -41.6,17.31 -64.3,26.72 -22.5,9.71 -46.1,19.92 -70.8,30.57 -24.7,10.76 -50.5,21.59 -77,33.49 -26.4,11.98 -53.7,24.37 -81.7,37.1 -28.2,12.54 -56.8,26.05 -86,40.04 -29.2,13.87 -59.1,28.04 -89.5,42.44 -60.2,29.85 -122.8,60.05 -185.2,92.91 -63,31.86 -125.8,66.51 -189,100.38 -62.6,35.06 -125.6,69.38 -186.3,105.36 -61.3,35.02 -120.4,71.53 -177.9,106.27 -28.5,17.86 -56.5,35.42 -83.9,52.6 -27.5,17.08 -54.3,33.95 -80,50.94 -25.8,16.82 -51,33.18 -75.3,49 -24.2,15.9 -47.2,31.87 -69.6,46.86 -22.2,15.1 -43.6,29.56 -63.9,43.32 -20.1,14.03 -39.1,27.34 -57,39.85 -18,12.51 -34.7,24.22 -50.3,35.05 -15.3,11.07 -29.4,21.23 -42.1,30.41 -50.8,36.86 -79.9,57.92 -79.9,57.92 0,0 28.7,-21.55 78.9,-59.26 12.6,-9.4 26.5,-19.8 41.6,-31.13 15.4,-11.09 31.9,-23.09 49.7,-35.9 17.7,-12.82 36.5,-26.47 56.4,-40.85 20.2,-13.99 41.4,-28.69 63.5,-44.03 22.2,-15.22 45.1,-31.43 69.2,-47.56 24.1,-16.07 49.1,-32.68 74.8,-49.76 25.6,-17.25 52.2,-34.39 79.6,-51.75 27.3,-17.43 55.1,-35.29 83.7,-53.07 57.5,-34.97 116.6,-71.7 177.8,-106.96 60.7,-36.21 123.6,-70.77 186.2,-106.07 63.3,-33.75 126.3,-68.22 189.5,-99.92 62.6,-32.69 125.4,-62.74 185.8,-92.42 30.3,-14.51 60.4,-28.42 89.7,-42.06 29.4,-13.73 58.2,-26.98 86.5,-39.26 28.2,-12.47 55.6,-24.6 82.1,-36.34 26.6,-11.66 52.6,-22.25 77.4,-32.78 24.8,-10.39 48.6,-20.35 71.2,-29.83 22.8,-9.02 44.4,-17.58 64.8,-25.62 20.3,-8.05 39.3,-15.58 56.9,-22.54 17.7,-6.68 34,-12.82 48.7,-18.37 58.8,-22.04 92.4,-34.64 92.4,-34.64 0,0 -33.4,13.17 -91.8,36.21 -14.6,5.79 -30.7,12.21 -48.3,19.19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch);
export default __webpack_public_path__ + "static/media/rocket-launch.838a6539178299881b8465c62a3a78c4.svg";
export { ForwardRef as ReactComponent };